var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilder1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192.885,
    height: 225,
    viewBox: "0 0 192.885 225",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gsgsgs",
    transform: "translate(-611.2 -190.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_931",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 931",
    d: "M776.274,1859.6v2.956L678.4,1806.046V1803.1Z",
    transform: "translate(-60.303 -1447.357)",
    fill: "#ceced0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_932",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 932",
    d: "M900.786,1414.092l-83.413,48.157L724.2,1408.457l83.423-48.157Z",
    transform: "translate(-101.402 -1050.005)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_933",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 933",
    d: "M1594.425,276.162,1537,243V357.666l7.626,4.4,49.8,28.749,7.626,4.4,28.112,16.237V296.792Z",
    transform: "translate(-830.779 -47.381)",
    fill: "#78c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_934",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 934",
    d: "M807.623,243,724.2,291.167V405.833l83.423-48.167Zm-17.212,83.382-44.821,25.885v-44.8l44.821-25.885Z",
    transform: "translate(-101.402 -47.381)",
    fill: "#4ebaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_935",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 935",
    d: "M1632,1908.777v2.956l88.114-50.877V1857.9Z",
    transform: "translate(-916.029 -1496.533)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_936",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 936",
    d: "M766.524,219.31,683.1,267.477l-4.7-2.71L761.823,216.6Z",
    transform: "translate(-60.303 -23.69)",
    fill: "#b8e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_937",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 937",
    d: "M683.1,803.275V688.61l-4.7-2.71V800.566Z",
    transform: "translate(-60.303 -444.823)",
    fill: "#78c8ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_938",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 938",
    d: "M1491.2,192.91l97.864,56.5,4.7-2.71L1495.9,190.2Z",
    transform: "translate(-789.68)",
    fill: "#b8e6ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_939",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 939",
    d: "M2444.7,858.085V743.41l4.7-2.71V855.366Z",
    transform: "translate(-1645.316 -493.999)",
    fill: "#4ebaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_86",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 86",
    transform: "translate(644.188 234.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_940",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 940",
    d: "M932.6,644.875v44.791l44.821-25.875V619Zm2.4,1.006,40.018-23.1v40L935,685.878Z",
    transform: "translate(-932.6 -619)",
    fill: "#d8ae7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_941",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 941",
    d: "M956,717.125V718.9l40.018-23.1v-40l-1.406.811v38.222Z",
    transform: "translate(-953.598 -652.023)",
    fill: "#e5bb91"
  }), /*#__PURE__*/React.createElement("image", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_33",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 33",
    width: 38.797,
    height: 60.658,
    transform: "translate(2.299 4.516)",
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_34",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 34",
    width: 38.797,
    height: 58.811,
    transform: "translate(2.299 4.516)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAXoAAAI9CAYAAAA0FbPZAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAE45JREFUeNrs3dFtHUmWBNBhohxpL8a0MaFNGy/alB4IDQIUIQ6px3pVeSPO+dn9JG/ejIwtSb0v/wIg0n/++/cfP/7ni1EAZAb8K0EPEBzygh4gOOAFPUB4wAt6gIKQF/QAwQEv6AHCA17QA4QHvKAHKAh5QQ8QHPCCHiA84AU9QHjAC3qAgpAX9ADBAS/oAcIDXtADFIS8oAcIDnhBDxAe8IIeIDzgBT1AQcgLeoDggBf0AOEB/+e/X/768bMdjgggK+DfW44KIC/kf7T51/9dowcIbPFvCXqAsIB/2+YFPUBgg3/PN3qAoJB/3+Y1eoCgFv+rkBf0AB8E/GtoJny6EfQAbwL9bSue/Aewgh7g/7T4NIIeEPC/CPiUNi/oAQFfQNADdSH/WcAntXlBD2jx4SEv6AEBX0DQAwI+uM0LeiA25JsbvKAHtPiiNi/ogfqA1+gBCgI+uc0LemB0yLc1+Ed/X0EPVLb4iW3+UYIeqAz4aSH/nd9b0AMjQt4ftGr0gBavzQt6QMBr9AAVAd/U5gU9sFXIa/Dnh7ygB2pa/MQ2fxZBD1QEfGubF/RAVcA3tnlBD1weshr8tW1e0APxLb69zQt6ID7gp4X8M2Yl6IHYgJ/mWfMS9MDpIb9TwDd/shH0gBZf0OYFPRAd8Nq8oAdOCFENfu82L+iBuBavzQt6IDzgtXlBDxQE/JQ2f9U8BT3waWBq8LMJeiCixWvzgh4ID/hJIa/RAwI+3NUzFvQg5CO+w2vzgh7Q4ivbvKAHAf9X2u8k5AU9CHkNvo6gBy1emw9u84IeBDwaPSDgtfnJbV7QQ3D4pTd4f51S0IMWjzYv6EHAa/P5IS/oQcBTQNDD4JBvDHhtXtCDFg+CHrRYc+hp84IehgabNs/vWEYA2qt55LZ5jR4GBpo2L+QFPWisZsNPfLqBQUHmr1Nq8xo9CDEQ9DA14LV5bV7QQ3Bw+QNYvsM3etBOzSu4zWv0MCCwtHkhL+hBIzU7BD1MDSltXps/g2/0oImaoUYP3BFO2rw2L+hB+zRPBD1MDST/OEqbP5Nv9CDkCT8bjR7CGqfZIuhh4xDS5rX5Z/DpBjRNM9boQfhojNq8oAcBj3kLehA42rw2fw/f6BHyWqW5h4b864w1egSNMBHy4TMW9Ah4CH+ABT0CXph4aMNn7Bs9wkXIE342Gj0CHucRPmNBj0DRGAk/G59uEPI4l5CQ/2jGGj2CRJgQTtAj4HFGwW1e0BMTHq+X1Ld5PKSCnrDFfhucmr027wEW9IS2+Cn84yjumrGgJyLgBQoeYEGPBi9MtPm4c/nqjAU92y/xZ5fRH8CCoEeLR5uvbfOCnvEBr82DoEeDR5uvbvOCnm0W9pGLp80j5AU9WjzaPIKeqQGvzaPNC3o2XlIhqM1zrRcjYEqL1+aFvDb/GI2eMQHv0wAIegoC3ucBbV6bF/RsspCNzVabdy4aPVqdNu/cuWXGgp7Tl1Cbx7ns9ZAKekY0Oc3RDvC4ZQScecG1eZzLfg+pRs/2DU5ztAsIeja51No8zmXPh1TQs3Vr0xzthcf3+3yj55TL/IzLJVCEvLun0bPJkvlkg3PZm6Bny6amOdoRMz6PTzd8a7m0eZzL/g+pRi/g/Vw4k3CC3qXVbP3OziX8IRX0At7PyOgz8fh+zjd6l9Xl8jsT/pBq9JbIz4o2H07Qu6Aul9/Zwxs+Y0FvcbYIPKGCx/d5fKMX8ggUuxQ+Y43ewmjzQt7jG/6QCnrLAqP2yuMr6F1EbV6g4P6+4xu9JQFtXqOn/QJq8zB75wW9xQBtPpxPNy6eNi9QCL/PGr2FEHho8+EEvcvm9ywPFCGfP2NBbwkEntZI+P32jd4S+H3tn8c3nEbvgrlcAoXwey7oBbzf3Xl4fDV6mkJOm4e8O+8bvZA3A+fh8dXoaQk3bR5nknn3Bb2Af/rl0ubtJ/fy6cYl0hxxJuEZoNELeG3enhI+X0Hv4miOdtWZhBP05QHf2OYFCm2Z4Bu9Fo+d9fhq9KQGvDaPM+nIBkGvwZuX80Cjd0G0KL8zzmRyTvhGL+TNzR6j0bsYeNxwJpPzQtCXBbw2b6fR6F0GPG722pmEZUf1N/q2kNfmEfKd+17Z6IWSULHfNDlcAIGXOld/AOtM5Mg/aj7daDnYczR6i69FafM4k8g8iQ16AS/wtHkIDXrLbtYeN2ciW34W9Y1eyAs8j649JLTRC3gzFyrImNCgF/ACD21ezoQGvYA3f4+bu8DXLYutzYM9zM6bw8DR5p0F2Q7LrEX5nXEm2dlzGLLL5UyEkJDPtiwxHjfIzqDDcAWesxFCHt5sh8XF4wbZebQMVeA5IyHk4c3e9cNA8bhBtsuDXsBr82jz5hsa9AIDoSLkucdqX1KBN+vchAoyarNGL+BBmyc06AW8Ni9U8JCGBr2AF3ho8+xnNSwk2jw059ZhUNo8QqhxD5uy6zAktHmch6AX8C4YHlzzHWwZDtq8c3AeGr2AL7hgzhgPaWnQu/xoj0JIm59vCXmB55MNHtKyRi/gBR5CyB6GBr2AFy5CheTzaM64Q8C7YAgh8822rIDl97jhPAQ9LhjapvkKeiy/x03ZQNDjgqFtmq+gR5t3Ds4DQa/Ngx3U5gW9C6bNCyEQ9Ah5tHlBjzaPczBfQQ/ao/NA0KPN4xzMV9DjccN5IOhdMC1H2xTy9lzQ43EDBL02j7apzQt6XDC/txBC0CNghLxH154LegQeQsh8BT3aPM4DQe+C4bG1g9q8oEebBwS9JoXHVptH0AsYwQKCHoGHNm++gp5dLpg2L4RA0IOy4SEV9GjzgiUthIQ8gh7BAoIebR5t3nwFPS6ANg+CXpvHY2sHtXlBjzYPCHptHo+tNo+gL7lg2jzOAkEP2qb5Iui1eQ0yLYR8skHQAwh6tHltXps3X0EPxSEPgl7gaTravEfXjgt6PG44CwS9S6bpaJvmi6DXpPzeOAsEvaaDMzBfBL0m5fd2Fgh6NB2cgfkKek3K7y2EnIWQF/QEXAKfCYQ8gt4lw0OL+Qp6tHmcBYLeJcNDa74IepfA46ZogKB3ydA2zRdBv2/Ia/M4CwQ9lLXNpJDX5gW9Nq/NCyHzRdCDogGCXpsXLtqm+SLoEfLOAkFPbZvXNjHfvBwT9GiQzgKN3iXTdrRNIW+/J+eYoNekNEgIv8+CXtsxfw+u/Q4n6G+6ZP46JR5RrrrPgh5B5MElvKwKem3eP47CfMMJevDgEr5Dgl6b1zadgzav0eNxAybf52VA/nGUNu/Btd/ZGbYMyO8NZPPpRtsxfw+u/Q4vbcuA/N44ByGfvUMavYtg/hCuMui1eZyDR7RphzR6F8H8IbwoLEPyewt55+ARzabRF1wEn2ygs7C9ZtAyJDyy9k+bzw35qqC/+pJp8zgHduHTDdo85hvc5muCXpvHOQj55v3R6NE2IfwOxAe9No9z8Ii27M9HZ6TRo81DeElYBqXNC3nn4BHNPiONHoQ8w/fns4d4GZQ2r21ivtnZtQzK741zIPsh9ulG4zF7zDe8JCyD8nvjHIR89hlp9C6D2cPAkvA7+7+aB+X3xjl4RBt2R6N3GcxeyBO+/zFBr82DAtNwhx85H43eZTB7jy3hu7MMy+8t5DHf7PMZH/R3hJ3LgDbPpN3x6WZoyGvzmG9XyH/nfFbbsDQBnIOQbzsfjd5lMHuPLeG7swzL741H1BT2vb9nnI9G7zKYvceW8N0fGfTaPCgw7q9G7zKYvceW0Xtz5u6vhoFpA6DANBsV9P5xlCDy2KLNFzR6iyLknYECI+RDg16bB3uNRq8RCCJngDY/Nehb27yAQZtX0DR6BJHHFrs/P+i1edDm09v8s89Go0cQeWwJ35llaNo8+WegzXefjUaPIIKbysFVe7+ShqbNC3ln4BFlSND7dAFCXpsvaPTavLk7A1JDvr7R+69TgjbvbDR6F8LcPbaM3Zk79n65aH5v/AEs2TtT3+hdCHOH9L3fJui1eZyBRzR5Z+48l+pG70KYOzQUg2Vwfm+X1iNK7rn82PHVetFcCEFktqQXg9ef11+vtDC1QeT/ouKKfdlh71fjRdN88MmG9HN5u+MavZARRBB2Z9//vKttcHcHjs8FLq1HtGNfdjoXjR5BBEE7/6uHae3yg2jzOAOPqH15zs9b0+hdCHOHK0J+x51fU4anGeAMPKI8tt+r4aK5EILIQ0tym//s5/WHsUIGjyiDQ/4r1u7DcyEEkYfWTvO9/dbohYwggqFt/qs/79p5eAIHD62dtivfp9FbHEEEA3f+d/Jl7fTDJAWOP4D10HpE83dlyplo9EQGkYcWD9NFQa/Ngzavzd//867dhocgsnsI+XPFfbrR5rHTeJguCHphJ4g8tEJem99nt5dLIWQEEUI+2zJAXF6PKLltPqrRa/PdQaRg8OxdmRrypwe9/9Y8aPPu6n6WS4E2D7lt/tSg1+ZBcUm8q9ND/rSgvzPsXApt3olgTy5q9JYHFBfnsWe2rN1+IJfC4rc+tPbZnjzr59XohYz5Y0/CH9419bJpP2ZutqSdx7MyVaPXJscFkTZP4p488+ddE4eo/eAR5Vn5lHgeGr02qc3Dzbv+7L1e0y7bnaEjZNDmlbGJP+9KHyLaPEK+/dEd9elGm3eBPaLY6ycHvbDT5jFbbX5eeVkuhgdO68Gjm225bGicZqsMZP+8y8XwwLkQtO5I+ieb3wp6l03jxGyZa7kYHrhdg0jBQJu/KOj9pw4Q8vZZyM/e6aVR+d0FEWTb9tONTzaamkcUbf7JQS/stHnMVshnFJfDxfDAafOQvcvLZUPjNFttPruwHC6GB04Dwn5k/4yHy6ZxuiDavD3P3t/Dxeh94AQRDW3+mXs+JTeWNo827xG1H9l7e7gY2jzY8+y8ONrbvP8rxvw9opn7cfY5TN7VY4cf3sUwb7Nl12BNKCPLImH+eHCzd/RIORBmzdsnG3bej7T9PCwSkHQ3v/PgpubCrUGvAWnzZssO55Be/Cq/0Wvz4G425cFtjV4D0ubNljN343fPoanwHZZJyEPTjjdmwNr9UPDIekTthh3U6B3ygCAS8tx5Du1/Lne0XA5/AAt9Bcy9L2z0mo42r81nhfxH5yDgf7YaLodDh54i475r9Nq8R1abD2nzAn7DoNfmgbPu5ds8ccc1em1em9fmPRb1VvLlsAguIZm7Yb82DHo0TrNFQAcHvTbfF0Q+2YBGD2jzXOhFm9c4zV6btxcavYUCEPRakMapzaN8VQW9TzYuM9iLgkaPxmm2EBr02rzWBvZCo0fjNFshz9Sg1+ZdaCEPGj3CCI8/FzvtH0xp830hr83jPmr0lsqFBlKCXgvSOM0Wj79Gb6lcaOwEN/n2/4cpLUjjNFsBj0ZvuVxs7AJTG70WpHGarYAnPOgtmQuO8yc46LWgrsaZesntsYBvsCycIPKA4s5p9C6Iy+6yO3Pagt7iaZxmK+AJDvo7Lojlc/FxzjzOf71S4zRbIS/kNXptXgDgfKkJenoap79OKeApDHptHgQ8M/lGr3Fq80IejV6bR8gLeOKDHm0eAc9cn3660eY1TrMV8mj0CAicHxt70eY1zuS5N7R5Ac+oRm9hwX3hfKu5CWmc2ryQR6O3uCDgyQx6bV6bN1sBj0ZviRHy7gZDLG1em0fIU9To/XVKIeIBdTaEBz3CCAFPnhdtvi/ktXkBTxf/mWIQ8jQ0em1emzdb50Cuw5JrjzgDsi1/MKhxmq2QR6O37JqkkDd7BD3aPAIeQW/xBU7JA2rP2Y2/XqnNI+TR6F2AySGvzZsz+EavXWLGCHqXIaFxmq2dptdyITRNzBaNHm3ebAU8gt7F0DhzQ94eI+jR5j2YsLXlkggnD6j9RaNnSJsXTmYIlwW9y8K0B9TOksx/AkGb1+LNDo3epdk95M3WrsKlQY9Gal4QHPTaPDvPVsDTarlE2qmQB42eTdu88DIjuCzoXSZ2e0DtJGj02rwGDzWWi0XKA2oXQaPX5rV4EPQuGJMeUPsHX+M/gaDNa/Gg0btoQn6f2Qp4uDDo4cqQF/BwcdBr89q83xvmWC4euz6gdg1ubPTCSKv1+0Jo0LuAPPMBtV+g0WvzGjzwzKB3GQWg3w9m8g+mNm7zAJcFvb9Oqe0CGj0AU4Nem9fmgeCgFzgABY1em9fmgdCgFzhCHtDotXmAqUGvWWrzgEavzQNMDXrNUpsHNHptHmBq0PvHUdo8oNEj5IGpQa/NA2R6af7l7wx6bR64vNELeQBBjzYPCHptHkDQa/PaPHCpuj+M9QewgEYPgEavzWvzgEYv5AEEfQ9tHhD02jyAoNfmAR4T/4ex/gAW0OgB0Oi1eW0e0OgB0Oi1eQCNPiDkAQR9OG0e2E3cpxufbAA0egCNXpvX5gGNHgCNXpsH0OgB0Oi1eQCN/jZCHhD04W0eYILRn258sgEoaPQAhDZ6bR5AowdgaqPX5gE0eiEPMLXR39HmBTww2WEEAh7Q6CvbvJAHNHotHkCjn9TmBTwg6ENDXsAD6ar/eqWQBzT60DYv4IEmVX8YK+ABjT60zQt4oFn8N3ohD2j0oW1ewAP8I+4bvYAHGNDoH23zQh5gQNA/EvICHuBjoz/dCHiAYY3+q21ewAN83bi/XinkAYY2+s/avIAHeMz23+gFPEBAo/9VmxfwAOfY8hu9kAcIavRv27yABwh05f/Db4BG/xNgAO8bobFeRSq+AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_85",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 85",
    transform: "translate(20.999 12.768)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_942",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 942",
    d: "M1137.2,788.006l2.823-1.632V743.4l-2.823,1.632Z",
    transform: "translate(-1137.2 -743.4)",
    fill: "#d8ae7e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_943",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 943",
    d: "M1333.606,695.8l-1.406-.965V656.611l1.406-.811Z",
    transform: "translate(-1291.186 -652.023)",
    fill: "#c69767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_944",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 944",
    d: "M1124.906,816.387l-1.406-.955V777.211l1.406-.811Z",
    transform: "translate(-1103.907 -760.245)",
    fill: "#c69767"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_90",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 90",
    transform: "translate(730.341 218.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_89",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 89",
    transform: "translate(34.127 19.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_945",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 945",
    d: "M2112.67,655.909v16.032c0,.185-.01.349-.021.5a1.923,1.923,0,0,1-.287.975,2.642,2.642,0,0,1-.934.78l-1.765,1.016a2.3,2.3,0,0,1-2.217-.226c-.954-.657-1.745-2.2-1.745-5.245l-1.17-8.858-.031-.246v-.031a3.424,3.424,0,0,1,.031-.472h0a2.287,2.287,0,0,1,.38-1.047,3.29,3.29,0,0,1,1.067-.913l5.224-3.017c.513-.3.872-.4,1.108-.3l.062.031C2112.578,655.026,2112.67,655.355,2112.67,655.909Z",
    transform: "translate(-2104.5 -654.823)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_946",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 946",
    d: "M2181.408,796.8v.164a.986.986,0,0,0-.308.657v-.164A.987.987,0,0,1,2181.408,796.8Z",
    transform: "translate(-2173.238 -782.228)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_947",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 947",
    d: "M2112.362,661.412V678.2a2.642,2.642,0,0,1-.934.78L2109.663,680a2.117,2.117,0,0,1-2.125.257.01.01,0,0,1-.01-.01c-.883-.5-1.642-2.042-2.053-5.594-.236-2.032-.821-7.708-.955-8.991-.01-.133-.021-.215-.021-.246v-.031a3.424,3.424,0,0,1,.031-.472h0a2.286,2.286,0,0,1,.38-1.047l5.768-3.326C2111.869,659.862,2112.362,660.036,2112.362,661.412Z",
    transform: "translate(-2104.5 -659.608)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_948",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 948",
    d: "M2112.452,670.342v15.734a2.115,2.115,0,0,1-.287.328,3.782,3.782,0,0,1-.636.452l-1.765,1.016a2.117,2.117,0,0,1-2.125.257.01.01,0,0,1-.01-.01c-.883-.5-1.642-2.042-2.053-5.594-.236-2.032-.821-7.708-.954-8.991-.01-.133-.021-.216-.021-.246v-.031a3.423,3.423,0,0,1,.031-.472h0l5.768-3.336.164-.092C2111.908,668.6,2112.452,668.8,2112.452,670.342Z",
    transform: "translate(-2104.59 -667.481)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_949",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 949",
    d: "M2112.164,672.3v15.8a3.789,3.789,0,0,1-.636.452l-1.765,1.016a2.117,2.117,0,0,1-2.125.257.01.01,0,0,1-.01-.01c-.883-.5-1.642-2.042-2.053-5.594-.236-2.032-.821-7.708-.954-8.991-.01-.133-.021-.216-.021-.246v-.031a3.424,3.424,0,0,1,.031-.472h0l5.768-3.336C2111.651,670.5,2112.164,670.775,2112.164,672.3Z",
    transform: "translate(-2104.59 -669.177)",
    fill: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_88",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 88",
    transform: "translate(5.768 2.327)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_950",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 950",
    d: "M2162.054,677.982a1.488,1.488,0,0,1-.677,1.17c-.369.216-.677.041-.677-.39a1.5,1.5,0,0,1,.677-1.17C2161.747,677.377,2162.054,677.551,2162.054,677.982Z",
    transform: "translate(-2160.7 -677.5)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_87",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 87",
    transform: "translate(0.175 0.227)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_951",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 951",
    d: "M2163.406,680.071a1.126,1.126,0,0,1-.5.872c-.277.164-.5.031-.5-.287a1.126,1.126,0,0,1,.5-.872C2163.18,679.619,2163.406,679.753,2163.406,680.071Z",
    transform: "translate(-2162.4 -679.713)",
    fill: "#e8e8e8"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_952",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 952",
    d: "M2182.665,818.6v.308c0,.185-.01.349-.021.5a.14.14,0,0,1-.093,0,.133.133,0,0,1-.051-.113v-.4A.382.382,0,0,1,2182.665,818.6Z",
    transform: "translate(-2174.495 -801.791)",
    fill: "#8c8c8c"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_953",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 953",
    d: "M1801.377,663.764a1.307,1.307,0,0,1-.277-.164Z",
    transform: "translate(-1798.113 -643.054)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_954",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 954",
    d: "M1818.255,483.1c-.236-.113-.6,0-1.109.3l-5.224,3.018a3.087,3.087,0,0,0-1.067.913l-26.3-15.17-7.759-4.475a3.186,3.186,0,0,1,1.068-.913l5.224-3.018c.585-.339.975-.431,1.2-.236h0Z",
    transform: "translate(-1776.307 -463.417)",
    fill: "#b2b2b2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_955",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 955",
    d: "M1800.4,479.9l4.547-2.627c.051-.031.1-.051.144-.072l31.376,18.095-4.034,2.33a5.851,5.851,0,0,0-.616.411Z",
    transform: "translate(-1797.485 -475.785)",
    fill: "#bcbcbc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_956",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 956",
    d: "M1807.524,524.555a2.286,2.286,0,0,0-.38,1.047h0l-1.191-.688-24.725-14.277-7.318-4.229-.811-.472h0a2.247,2.247,0,0,1,.38-1.037l.811.462,6.948,4,24.623,14.225Z",
    transform: "translate(-1772.987 -500.642)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_957",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 957",
    d: "M1773.11,515.1Z",
    transform: "translate(-1772.987 -509.795)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_958",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 958",
    d: "M1809.883,550.168l-1.591-.913-31.776-18.341-.544-.318-.277-.164h0c-.811-.585-1.519-2.145-1.909-5.5-.226-1.981-.79-7.4-.944-8.878,0-.051-.01-.092-.01-.123l-.031-.246v-.041a3.085,3.085,0,0,1,.031-.441h0l.811.472,32.043,18.5,1.191.688h0a3.067,3.067,0,0,0-.031.441v.062c0,.031.01.113.021.246,0,.041.01.082.01.123.154,1.5.708,6.9.934,8.868C1808.24,548.126,1809.01,549.665,1809.883,550.168Z",
    transform: "translate(-1772.718 -509.885)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_959",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 959",
    d: "M1833.31,659.6l-30.134-17.387-.267-.154a.01.01,0,0,0-.01-.01,3.5,3.5,0,0,1-1.119-1.827c-.113-.349-.226-.749-.328-1.211-.021-.1-.041-.205-.051-.308l30.268,17.469c.021.113.051.216.062.318a12.447,12.447,0,0,0,.328,1.211A3.286,3.286,0,0,0,1833.31,659.6Z",
    transform: "translate(-1798.383 -620.71)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_960",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 960",
    d: "M1835.368,663.243l-29.775-17.181-.257-.144a.01.01,0,0,0-.01-.01,3.4,3.4,0,0,1-1.1-1.806,12.144,12.144,0,0,1-.328-1.2l29.908,17.263a11.909,11.909,0,0,0,.328,1.191A3.2,3.2,0,0,0,1835.368,663.243Z",
    transform: "translate(-1800.626 -624.478)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_961",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 961",
    d: "M1773.1,515.1h.01Z",
    transform: "translate(-1772.987 -509.795)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_962",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 962",
    d: "M1801,663.6Z",
    transform: "translate(-1798.024 -643.054)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("image", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_35",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 35",
    width: 3.9,
    height: 16.935,
    transform: "translate(0 4.165)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAClCAYAAAAwGY/YAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYpJREFUeNrs3FEKg0AMhGHjYXuoXtY+FYqodHUzGde/74WPTHa0FJ2m1WdZltdk8IkjWES8LWB706oARkuMSmC07pYKN7d+QXU4ZqeTeGlitlFaTkx5KseYmLRg3fqLKIFZwSpue+bKm0F2DFjlLyeiBCaBOZYsUQKzganbnyiByWBu7U+UwKxgyvYnSmBSmFP7E+VzYdJ/34gSmBLmUrJECcwSpmh/ogRWAnNof6IEll2yRAmsDFZdskQJzBqW2f5ECawUVtn+RAksu2SJElg5rKpkiRLYLWAZ7U+Uz4KVPGVDlMDuAutdskSZBuNRWWDARF3GSxLYMWBuJ3OcifGyF2AOsB4n8xRMcQDYsWFgkbnkV3aRKNmx7D0jSjks6/KUPrGzF/SxdywjTsnEzsQ5fl30jlM2sdY4u8J6Tk26Yy1T6w7rNbVxb3vOxPbPVJ83satTS53YlYMQlTVxBA/VzrTiZMvfGmuoT9vW5LbQUVEF/+BKYHvAX1wpbAv4xVnAtnA2sDXwI8AATX+XD98+LOYAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_36",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 36",
    width: 3.798,
    height: 16.935,
    transform: "translate(33.254 23.358)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACUAAAClCAYAAADbLjTbAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAYtJREFUeNrs3EsOwjAMhOE6h+VQXLaIBZuKR93EY5P8XYP0yeOMCohu2+Ha9/22JV/2DWRm93KoLJx5YlPhmufFqn1r3jcoYK3KieualGKv2lbwatWmVHZSdnbJlQX6/zsFqtI+Ed//o7LuLolvbZT6JpD4QK2DqtbqxLcGStnqxAcqDFWpQIkPVCqq7FfWoEB5UFVanfhApaNkv/cRH6hIVIVWJ771UNEFSnygJKjsAiU+UGVQka1OfKBkqMxWJ751UVEFSnygpKisAiU+UOVQEa1OfHOjMgqU+ECVRI0uUOKbH8WfeUCBCihQ4huO4o+soEAN7iqeAsBOgco6gXNMiqeVgMpA9Z7AS6joZWen0lE9e3UZFblX7JQEFRVh6KSuLjs7dXotFDF5d2/e+EafQsmkvKdw7tM3MkLZpDwRDkWNmta85emJ6sw015lU77TWmlTPtEIndbUiTBGH98nPptoTD0y26J4oTX2y3k3sCLaMI/8LloL6hHvBUlHvcE9YCVTPB1cZ7iHAAF68ldWh2nAvAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_963",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 963",
    d: "M1854.1,669.05s6.456-.564,16.6,9.576Z",
    transform: "translate(-1845.673 -647.94)",
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_100",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 100",
    transform: "translate(611.2 333.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_91",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 91",
    transform: "translate(2.474 30.976)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_964",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 964",
    d: "M657.931,1902.4v1.8l-3.531,2.042v-.544l2.1-1.55a1.483,1.483,0,0,1,.431-1.006h0a3.494,3.494,0,0,1,1-.739Z",
    transform: "translate(-652.44 -1901.199)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_965",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 965",
    d: "M635.3,1909.34l1.96,1.2,2.1-1.55-1.96-1.191Z",
    transform: "translate(-635.3 -1906.045)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_966",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 966",
    d: "M658.281,1899.37h0a1.524,1.524,0,0,0-.431,1.006l-1.211-.739-.739-.452a1.533,1.533,0,0,1,.411-.985h0l1.016.606Z",
    transform: "translate(-653.786 -1897.43)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_967",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 967",
    d: "M662.776,1891.9h0a3.478,3.478,0,0,0-1.006.739h0l-.954-.575-1.016-.605a3.639,3.639,0,0,1,1.016-.76h0Z",
    transform: "translate(-657.285 -1890.7)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_968",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 968",
    d: "M635.3,1923.344l1.96,1.2V1924l-1.96-1.2Z",
    transform: "translate(-635.3 -1919.505)",
    fill: "#afafaf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_92",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 92",
    transform: "translate(21.523 42.061)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_969",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 969",
    d: "M843.531,2010.4v1.8L840,2014.239v-.544l2.1-1.55a1.53,1.53,0,0,1,.431-1.006h0a3.566,3.566,0,0,1,1-.739Z",
    transform: "translate(-838.04 -2009.199)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_970",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 970",
    d: "M820.9,2017.35l1.96,1.191,2.094-1.54-1.95-1.2Z",
    transform: "translate(-820.9 -2014.045)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_971",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 971",
    d: "M843.691,2007.37h0a1.524,1.524,0,0,0-.431,1.006l-1.221-.739-.739-.452a1.532,1.532,0,0,1,.411-.985h0l1.016.606Z",
    transform: "translate(-839.206 -2005.43)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_972",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 972",
    d: "M848.376,1999.9h0a3.472,3.472,0,0,0-1.006.739h0l-.954-.575-1.016-.606a3.641,3.641,0,0,1,1.016-.76h0Z",
    transform: "translate(-842.885 -1998.7)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_973",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 973",
    d: "M820.9,2031.444l1.96,1.2v-.554l-1.96-1.191Z",
    transform: "translate(-820.9 -2027.595)",
    fill: "#afafaf"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_93",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 93",
    transform: "translate(0.339)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_974",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 974",
    d: "M654.836,1607.351l-8.447,4.9h0a2.157,2.157,0,0,0-.7-.7l-23.74-13.7h0l-1.3-.76-5.43-3.13a.755.755,0,0,0-.718-.092l8.385-4.885a.734.734,0,0,1,.77.062l30.473,17.592A2.157,2.157,0,0,1,654.836,1607.351Z",
    transform: "translate(-614.5 -1588.896)",
    fill: "#efefef"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_94",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 94",
    transform: "translate(1.827 7.914)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A_37",
    "data-name": "\\u041F\\u0440\\u044F\\u043C\\u043E\\u0443\\u0433\\u043E\\u043B\\u044C\\u043D\\u0438\\u043A 37",
    width: 18.372,
    height: 29.765,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAALMAAAEiCAYAAACyWeOhAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOJJREFUeNrswQEBAAAAgiD/r25IQAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAPBlAgwALGcAAb0TkFkAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_96",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 96",
    transform: "translate(0 4.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_975",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 975",
    d: "M643.818,1656.488v21.574a.79.79,0,0,1-.246.647h-.01a.7.7,0,0,1-.113.072h-.01a.852.852,0,0,1-.7-.1l-30.473-17.592a2.347,2.347,0,0,1-1.067-1.858v-21.574a.76.76,0,0,1,.3-.688h0l.041-.021h.01a.783.783,0,0,1,.718.092l5.43,3.13,1.3.76h0l23.74,13.7a2.158,2.158,0,0,1,.7.7A2.286,2.286,0,0,1,643.818,1656.488Z",
    transform: "translate(-611.2 -1636.894)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_976",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 976",
    d: "M643.8,1695.355a.925.925,0,0,1-1.457.76l-16.2-9.35a2.3,2.3,0,0,1-1.047-1.807v-17.582c0-1.047.718-1.293,1.293-.965l15.95,9.709a2.3,2.3,0,0,1,1.047,1.806Z",
    transform: "translate(-623.673 -1663.26)",
    fill: "#f4f4f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_977",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 977",
    d: "M647.49,1695.812c0,.667-.472.934-1.047.606l-16.2-9.35a2.3,2.3,0,0,1-1.047-1.806v-17.582c0-.667.472-.934,1.047-.605l16.2,9.35a2.3,2.3,0,0,1,1.047,1.806Z",
    transform: "translate(-627.353 -1663.85)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_978",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 978",
    d: "M654.637,1723.888c0,5.173-3.633,7.277-8.119,4.69s-8.119-8.888-8.119-14.061,3.633-7.277,8.119-4.691S654.637,1718.705,654.637,1723.888Z",
    transform: "translate(-635.608 -1701.349)",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_979",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 979",
    d: "M710.347,1800.893c0,.585-.411.831-.924.534a2.047,2.047,0,0,1-.924-1.6c0-.585.411-.831.924-.534A2.047,2.047,0,0,1,710.347,1800.893Z",
    transform: "translate(-698.513 -1782.51)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_95",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 95",
    transform: "translate(1.847 3.069)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_980",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 980",
    d: "M690.2,1825.836a9.709,9.709,0,0,0,1.314,1.745l.226-.513a7.927,7.927,0,0,1-1.119-1.468Z",
    transform: "translate(-683.939 -1809.301)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_981",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 981",
    d: "M699.7,1820.336a6.2,6.2,0,0,0,.862,1.129l.226-.513a5,5,0,0,1-.667-.852Z",
    transform: "translate(-692.464 -1804.366)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_982",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 982",
    d: "M695,1823.136a7.547,7.547,0,0,0,1.088,1.437l.226-.513a6.219,6.219,0,0,1-.893-1.16Z",
    transform: "translate(-688.247 -1806.878)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_983",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 983",
    d: "M685.4,1828.636a10.993,10.993,0,0,0,1.55,2.053l.226-.513a10.144,10.144,0,0,1-1.355-1.776Z",
    transform: "translate(-679.632 -1811.814)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_984",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 984",
    d: "M767.781,1785.492a17.547,17.547,0,0,0-1.56-3.592l-.421.246a16.569,16.569,0,0,1,1.427,3.295Z",
    transform: "translate(-751.78 -1770.086)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_985",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 985",
    d: "M704.921,1817.3l-.421.246a5.581,5.581,0,0,0,.626.821l.226-.513A4.688,4.688,0,0,1,704.921,1817.3Z",
    transform: "translate(-696.771 -1801.853)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_986",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 986",
    d: "M680.6,1831.336a12.691,12.691,0,0,0,1.776,2.361l.226-.513a11.365,11.365,0,0,1-1.581-2.083Z",
    transform: "translate(-675.324 -1814.237)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_987",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 987",
    d: "M772.725,1783.131a19.225,19.225,0,0,0-1.7-3.931l-.421.246a17.44,17.44,0,0,1,1.57,3.644Z",
    transform: "translate(-756.087 -1767.664)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_988",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 988",
    d: "M656.5,1806a16.1,16.1,0,0,0,1.468,3.315l.421-.246a14.55,14.55,0,0,1-1.334-3.018Z",
    transform: "translate(-653.698 -1791.713)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_989",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 989",
    d: "M693.8,1809.4a7.036,7.036,0,0,0,.575,1.273l.421-.246a4.908,4.908,0,0,1-.441-.975Z",
    transform: "translate(-687.17 -1794.764)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_990",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 990",
    d: "M729.862,1785.327a8.453,8.453,0,0,0-1.037-1.427l-.226.513a6.267,6.267,0,0,1,.831,1.16Z",
    transform: "translate(-718.398 -1771.881)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_991",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 991",
    d: "M637.4,1765a14.357,14.357,0,0,0,.647,4.013l.554.051a13.293,13.293,0,0,1-.6-3.716Z",
    transform: "translate(-636.558 -1754.921)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_992",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 992",
    d: "M700,1810a4.41,4.41,0,0,0,.421.924l.421-.246a3.192,3.192,0,0,1-.287-.636Z",
    transform: "translate(-692.733 -1795.302)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_993",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 993",
    d: "M727.126,1790.819a6.712,6.712,0,0,0-.8-1.119l-.226.513a5.109,5.109,0,0,1,.606.852Z",
    transform: "translate(-716.154 -1777.086)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_994",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 994",
    d: "M706.477,1811.185l.842-.482-1.119-.1A3.778,3.778,0,0,0,706.477,1811.185Z",
    transform: "translate(-698.297 -1795.841)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_995",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 995",
    d: "M737.054,1868.628a.777.777,0,0,1-.154-.01l.246.811a2.817,2.817,0,0,0,1.632-.349h.01l-.452-.78h-.01A2.452,2.452,0,0,1,737.054,1868.628Z",
    transform: "translate(-725.846 -1847.619)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_996",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 996",
    d: "M630.7,1761.1a15.418,15.418,0,0,0,.708,4.362l.554.052a14.32,14.32,0,0,1-.647-4.054Z",
    transform: "translate(-630.546 -1751.421)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_997",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 997",
    d: "M664.4,1780.6a9.77,9.77,0,0,0,.431,2.648l.554.051a8.289,8.289,0,0,1-.369-2.34Z",
    transform: "translate(-660.787 -1768.92)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_998",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 998",
    d: "M671.2,1784.5a8.484,8.484,0,0,0,.38,2.309l.554.051a6.95,6.95,0,0,1-.318-2Z",
    transform: "translate(-666.889 -1772.42)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_999",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 999",
    d: "M657.7,1776.7a11.054,11.054,0,0,0,.482,2.987l.554.051a9.3,9.3,0,0,1-.431-2.689Z",
    transform: "translate(-654.775 -1765.42)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1000",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1000",
    d: "M644.2,1768.9a13.073,13.073,0,0,0,.6,3.674l.554.051a11.973,11.973,0,0,1-.534-3.366Z",
    transform: "translate(-642.66 -1758.421)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1001",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1001",
    d: "M732.588,1779.834a9.758,9.758,0,0,0-1.262-1.734l-.226.513a8.152,8.152,0,0,1,1.067,1.468Z",
    transform: "translate(-720.641 -1766.677)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1002",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1002",
    d: "M650.9,1772.8a11.735,11.735,0,0,0,.544,3.336l.554.051a10.637,10.637,0,0,1-.482-3.028Z",
    transform: "translate(-648.673 -1761.921)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1003",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1003",
    d: "M777.579,1780.68a21.2,21.2,0,0,0-1.858-4.28l-.421.246a19.393,19.393,0,0,1,1.724,3.982Z",
    transform: "translate(-760.305 -1765.151)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1004",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1004",
    d: "M644,1804.9a19.4,19.4,0,0,0,1.765,3.993l.421-.246a17.861,17.861,0,0,1-1.632-3.695Z",
    transform: "translate(-642.481 -1790.726)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1005",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1005",
    d: "M782.522,1778.219a22.548,22.548,0,0,0-2-4.619l-.421.246a21,21,0,0,1,1.868,4.321Z",
    transform: "translate(-764.612 -1762.638)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1006",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1006",
    d: "M650.2,1805.5a18.265,18.265,0,0,0,1.611,3.654l.421-.246a15.915,15.915,0,0,1-1.478-3.356Z",
    transform: "translate(-648.045 -1791.264)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1007",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1007",
    d: "M631.6,1803.8a22.736,22.736,0,0,0,2.063,4.68l.421-.246a21.256,21.256,0,0,1-1.93-4.383Z",
    transform: "translate(-631.354 -1789.739)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1008",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1008",
    d: "M637.8,1804.3a21.009,21.009,0,0,0,1.909,4.331l.421-.246a19.309,19.309,0,0,1-1.776-4.044Z",
    transform: "translate(-636.917 -1790.188)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1009",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1009",
    d: "M719.521,1801.2l-.421.944.759-.441A2.87,2.87,0,0,0,719.521,1801.2Z",
    transform: "translate(-709.873 -1787.406)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1010",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1010",
    d: "M709.7,1813.2l.441-1-.842.482A3.271,3.271,0,0,0,709.7,1813.2Z",
    transform: "translate(-701.079 -1797.277)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1011",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1011",
    d: "M687.6,1808.9a8.052,8.052,0,0,0,.718,1.611l.421-.246a6.505,6.505,0,0,1-.585-1.314Z",
    transform: "translate(-681.606 -1794.315)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1012",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1012",
    d: "M724.3,1796.211a5.022,5.022,0,0,0-.575-.811l-.226.513a3.428,3.428,0,0,1,.38.544Z",
    transform: "translate(-713.821 -1782.201)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1013",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1013",
    d: "M675.1,1807.7a11.628,11.628,0,0,0,1.016,2.289l.421-.246a9.513,9.513,0,0,1-.883-1.991Z",
    transform: "translate(-670.389 -1793.239)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1014",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1014",
    d: "M675.9,1834.136a14.859,14.859,0,0,0,2,2.668l.226-.513a12.725,12.725,0,0,1-1.806-2.391Z",
    transform: "translate(-671.107 -1816.749)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1015",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1015",
    d: "M681.3,1808.3a9.157,9.157,0,0,0,.872,1.95l.421-.246a7.912,7.912,0,0,1-.739-1.652Z",
    transform: "translate(-675.953 -1793.777)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1016",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1016",
    d: "M662.7,1806.6a14.7,14.7,0,0,0,1.314,2.977l.421-.246a12.9,12.9,0,0,1-1.18-2.679Z",
    transform: "translate(-659.262 -1792.251)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1017",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1017",
    d: "M668.9,1807.2a12.464,12.464,0,0,0,1.17,2.627l.421-.246a11.549,11.549,0,0,1-1.037-2.34Z",
    transform: "translate(-664.825 -1792.79)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1018",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1018",
    d: "M755.775,1836.625a4.8,4.8,0,0,0,.318-1.765l-.616-.359a4.166,4.166,0,0,1-.277,1.509Z",
    transform: "translate(-742.268 -1817.288)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1019",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1019",
    d: "M774.575,1849.146a6.765,6.765,0,0,0,.472-2.586l-.616-.359a6.166,6.166,0,0,1-.431,2.33Z",
    transform: "translate(-759.138 -1827.787)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1020",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1020",
    d: "M793.632,1822.631a15.546,15.546,0,0,0-.677-4.28l-.554-.051a14.411,14.411,0,0,1,.626,3.972Z",
    transform: "translate(-775.65 -1802.751)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1021",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1021",
    d: "M728.39,1804.772a4.936,4.936,0,0,0-.37-.872l-.421.246a3.084,3.084,0,0,1,.236.575Z",
    transform: "translate(-717.501 -1789.828)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1022",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1022",
    d: "M786.985,1857.49a8.044,8.044,0,0,0,.565-3.13l-.616-.359a7.593,7.593,0,0,1-.534,2.874Z",
    transform: "translate(-770.265 -1834.786)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1023",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1023",
    d: "M793.285,1861.567a8.749,8.749,0,0,0,.616-3.408l-.616-.359a8.139,8.139,0,0,1-.585,3.151Z",
    transform: "translate(-775.919 -1838.196)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1024",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1024",
    d: "M730.788,1813.6a3.58,3.58,0,0,0-.133-.852l-.554-.051a2.072,2.072,0,0,1,.082.554Z",
    transform: "translate(-719.744 -1797.725)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1025",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1025",
    d: "M720.954,1811.882,720,1811.8l1.037.6A3.127,3.127,0,0,0,720.954,1811.882Z",
    transform: "translate(-710.681 -1796.918)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1026",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1026",
    d: "M749.475,1832.458a4.114,4.114,0,0,0,.267-1.5l-.616-.359a3.481,3.481,0,0,1-.226,1.242Z",
    transform: "translate(-736.614 -1813.788)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1027",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1027",
    d: "M768.275,1844.969a6.266,6.266,0,0,0,.421-2.309l-.616-.359a5.592,5.592,0,0,1-.38,2.053Z",
    transform: "translate(-753.485 -1824.287)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1028",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1028",
    d: "M736.885,1824.114a2.648,2.648,0,0,0,.164-.955l-.616-.359a2.059,2.059,0,0,1-.133.7Z",
    transform: "translate(-725.308 -1806.789)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1029",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1029",
    d: "M743.185,1828.281a3.414,3.414,0,0,0,.216-1.221l-.616-.359a2.689,2.689,0,0,1-.185.965Z",
    transform: "translate(-730.961 -1810.288)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1030",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1030",
    d: "M671.1,1836.936a16.56,16.56,0,0,0,2.227,2.976l.226-.513a13.983,13.983,0,0,1-2.032-2.7Z",
    transform: "translate(-666.799 -1819.262)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1031",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1031",
    d: "M761.975,1840.8a5.581,5.581,0,0,0,.369-2.042l-.616-.359a4.9,4.9,0,0,1-.328,1.786Z",
    transform: "translate(-747.831 -1820.787)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1032",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1032",
    d: "M780.685,1853.312a7.3,7.3,0,0,0,.513-2.853l-.616-.359a6.812,6.812,0,0,1-.482,2.6Z",
    transform: "translate(-764.612 -1831.287)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1033",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1033",
    d: "M747.718,1901.913c-.1,0-.216,0-.318-.01l.246.811a4.33,4.33,0,0,0,2.515-.534h.01l-.452-.78h-.01A3.893,3.893,0,0,1,747.718,1901.913Z",
    transform: "translate(-735.268 -1877.322)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1034",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1034",
    d: "M762.165,1818.117a9.545,9.545,0,0,0-.411-2.566l-.554-.051a8.058,8.058,0,0,1,.349,2.258Z",
    transform: "translate(-747.652 -1800.238)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1035",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1035",
    d: "M744.977,1893.572a2.5,2.5,0,0,1-.277-.01l.246.811a3.909,3.909,0,0,0,2.289-.493h.01l-.452-.78h-.01A3.465,3.465,0,0,1,744.977,1893.572Z",
    transform: "translate(-732.845 -1869.873)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1036",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1036",
    d: "M768.516,1819.056a10.9,10.9,0,0,0-.462-2.9l-.554-.052a9.416,9.416,0,0,1,.4,2.607Z",
    transform: "translate(-753.305 -1800.776)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1037",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1037",
    d: "M742.336,1885.321a1.818,1.818,0,0,1-.236-.01l.246.811a3.613,3.613,0,0,0,2.073-.441h.01l-.452-.78h-.01A3.248,3.248,0,0,1,742.336,1885.321Z",
    transform: "translate(-730.512 -1862.515)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1038",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1038",
    d: "M774.767,1819.905a12.26,12.26,0,0,0-.513-3.254l-.554-.051a10.407,10.407,0,0,1,.462,2.946Z",
    transform: "translate(-758.869 -1801.225)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1039",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1039",
    d: "M755.813,1817.178a8.26,8.26,0,0,0-.359-2.227l-.554-.051a7.1,7.1,0,0,1,.3,1.919Z",
    transform: "translate(-741.998 -1799.7)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1040",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1040",
    d: "M750.359,1910.254c-.113,0-.236,0-.359-.01l.246.811a4.7,4.7,0,0,0,2.73-.575h.01l-.452-.78h-.01A4.3,4.3,0,0,1,750.359,1910.254Z",
    transform: "translate(-737.602 -1884.77)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1041",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1041",
    d: "M737.049,1814.452a4.579,4.579,0,0,0-.2-1.2l-.554-.051a3.426,3.426,0,0,1,.133.893Z",
    transform: "translate(-725.308 -1798.174)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1042",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1042",
    d: "M749.652,1816.329a7.222,7.222,0,0,0-.3-1.878l-.554-.051a6.169,6.169,0,0,1,.246,1.581Z",
    transform: "translate(-736.525 -1799.251)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1043",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1043",
    d: "M787.28,1821.782a14.071,14.071,0,0,0-.626-3.931l-.554-.051a13.1,13.1,0,0,1,.564,3.633Z",
    transform: "translate(-769.996 -1802.302)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1044",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1044",
    d: "M743.3,1815.391a5.936,5.936,0,0,0-.246-1.54l-.554-.051a4.375,4.375,0,0,1,.185,1.232Z",
    transform: "translate(-730.871 -1798.713)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1045",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1045",
    d: "M720.26,1806.7l-.76.441.975.092A2.648,2.648,0,0,0,720.26,1806.7Z",
    transform: "translate(-710.232 -1792.341)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1046",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1046",
    d: "M777.63,1889.916l-.585-.616a4.477,4.477,0,0,1-1.745,2.053l.452.78A4.721,4.721,0,0,0,777.63,1889.916Z",
    transform: "translate(-760.305 -1866.463)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1047",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1047",
    d: "M767.822,1876.816l-.585-.616a3.723,3.723,0,0,1-1.437,1.693l.452.78A4.024,4.024,0,0,0,767.822,1876.816Z",
    transform: "translate(-751.78 -1854.708)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1048",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1048",
    d: "M752.97,1857.116l-.585-.616a2.642,2.642,0,0,1-.985,1.17l.452.78A2.831,2.831,0,0,0,752.97,1857.116Z",
    transform: "translate(-738.858 -1837.03)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1049",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1049",
    d: "M762.878,1870.216l-.585-.616a3.367,3.367,0,0,1-1.293,1.519l.452.78A3.625,3.625,0,0,0,762.878,1870.216Z",
    transform: "translate(-747.472 -1848.785)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1050",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1050",
    d: "M757.924,1863.716l-.585-.616a3.009,3.009,0,0,1-1.139,1.344l.452.78A3.251,3.251,0,0,0,757.924,1863.716Z",
    transform: "translate(-743.165 -1842.952)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1051",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1051",
    d: "M753.029,1792.676a13.453,13.453,0,0,0-1.108-2.576l-.421.246a10.807,10.807,0,0,1,.975,2.278Z",
    transform: "translate(-738.948 -1777.445)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1052",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1052",
    d: "M772.776,1883.316l-.585-.616a4.143,4.143,0,0,1-1.591,1.868l.452.78A4.341,4.341,0,0,0,772.776,1883.316Z",
    transform: "translate(-756.087 -1860.541)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1053",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1053",
    d: "M661.5,1842.346a19.228,19.228,0,0,0,2.689,3.582l.226-.513a17.856,17.856,0,0,1-2.494-3.315Z",
    transform: "translate(-658.185 -1824.108)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1054",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1054",
    d: "M782.584,1896.416,782,1895.8a4.844,4.844,0,0,1-1.9,2.227l.452.78A5.047,5.047,0,0,0,782.584,1896.416Z",
    transform: "translate(-764.612 -1872.296)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1055",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1055",
    d: "M656.8,1845.136a20.888,20.888,0,0,0,2.915,3.9l.226-.513a19.109,19.109,0,0,1-2.72-3.623Z",
    transform: "translate(-653.967 -1826.62)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1056",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1056",
    d: "M666.3,1839.546a17.091,17.091,0,0,0,2.463,3.274l.226-.513a16.162,16.162,0,0,1-2.268-3.007Z",
    transform: "translate(-662.492 -1821.595)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1057",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1057",
    d: "M762.827,1787.954a16.76,16.76,0,0,0-1.406-3.254l-.421.246a14.357,14.357,0,0,1,1.273,2.956Z",
    transform: "translate(-747.472 -1772.599)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1058",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1058",
    d: "M757.883,1790.315a13.989,13.989,0,0,0-1.262-2.915l-.421.246a13.007,13.007,0,0,1,1.129,2.617Z",
    transform: "translate(-743.165 -1775.022)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1059",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1059",
    d: "M743.132,1797.588a9.526,9.526,0,0,0-.811-1.888l-.421.246a7.642,7.642,0,0,1,.677,1.591Z",
    transform: "translate(-730.333 -1782.47)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1060",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1060",
    d: "M728.311,1824.416l-.585-.616a.674.674,0,0,1-.226.277l.452.78A1.023,1.023,0,0,0,728.311,1824.416Z",
    transform: "translate(-717.411 -1807.686)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1061",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1061",
    d: "M733.265,1830.916l-.585-.616a1.126,1.126,0,0,1-.38.462l.452.78A1.351,1.351,0,0,0,733.265,1830.916Z",
    transform: "translate(-721.718 -1813.519)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1062",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1062",
    d: "M721.124,1814.765l-.924-.965.718,1.242A.812.812,0,0,0,721.124,1814.765Z",
    transform: "translate(-710.86 -1798.712)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1063",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1063",
    d: "M738.188,1800.05a8.507,8.507,0,0,0-.667-1.55l-.421.246a6.644,6.644,0,0,1,.534,1.252Z",
    transform: "translate(-726.026 -1784.983)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1064",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1064",
    d: "M733.334,1802.411a6.207,6.207,0,0,0-.513-1.211l-.421.246a4.7,4.7,0,0,1,.39.913Z",
    transform: "translate(-721.808 -1787.406)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1065",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1065",
    d: "M721.4,1813.475l-1-.575.934.975A1.172,1.172,0,0,0,721.4,1813.475Z",
    transform: "translate(-711.039 -1797.905)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1066",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1066",
    d: "M738.308,1837.516l-.585-.616a1.526,1.526,0,0,1-.523.636l.452.78A1.889,1.889,0,0,0,738.308,1837.516Z",
    transform: "translate(-726.115 -1819.441)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1067",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1067",
    d: "M743.162,1844.016l-.585-.616a1.9,1.9,0,0,1-.677.811l.452.78A2.077,2.077,0,0,0,743.162,1844.016Z",
    transform: "translate(-730.333 -1825.274)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1068",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1068",
    d: "M748.116,1850.616l-.585-.616a2.2,2.2,0,0,1-.831.985l.452.78A2.557,2.557,0,0,0,748.116,1850.616Z",
    transform: "translate(-734.64 -1831.197)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1069",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1069",
    d: "M748.086,1795.227a10.913,10.913,0,0,0-.965-2.227l-.421.246a9.446,9.446,0,0,1,.831,1.94Z",
    transform: "translate(-734.64 -1780.047)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1070",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1070",
    d: "M730.585,1819.937a1.952,1.952,0,0,0,.113-.677l-.616-.359a1.333,1.333,0,0,1-.082.421Z",
    transform: "translate(-719.654 -1803.289)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1071",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1071",
    d: "M739.7,1876.98a1.244,1.244,0,0,1-.2-.01l.246.811a3.192,3.192,0,0,0,1.847-.4h.01l-.452-.78h-.01A2.872,2.872,0,0,1,739.7,1876.98Z",
    transform: "translate(-728.179 -1855.067)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1072",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1072",
    d: "M781.029,1820.844a12.787,12.787,0,0,0-.575-3.592l-.554-.051a11.691,11.691,0,0,1,.513,3.284Z",
    transform: "translate(-764.433 -1801.763)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1073",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1073",
    d: "M677.966,1734.231l-.246-.811c-.133-.01-.267-.021-.4-.021a3.168,3.168,0,0,0-1.519.37l.452.78A3.011,3.011,0,0,1,677.966,1734.231Z",
    transform: "translate(-671.017 -1726.564)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1074",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1074",
    d: "M682.54,1742.931l-.246-.811c-.123-.01-.236-.021-.359-.021a2.786,2.786,0,0,0-1.334.318l.452.78A2.672,2.672,0,0,1,682.54,1742.931Z",
    transform: "translate(-675.324 -1734.371)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1075",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1075",
    d: "M687.114,1751.631l-.246-.811c-.113-.01-.216-.021-.318-.021a2.379,2.379,0,0,0-1.15.277l.452.78A2.266,2.266,0,0,1,687.114,1751.631Z",
    transform: "translate(-679.632 -1742.179)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1076",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1076",
    d: "M718.7,1750.2v.708a8.649,8.649,0,0,1,1.745,1.427l.226-.513A9.354,9.354,0,0,0,718.7,1750.2Z",
    transform: "translate(-709.514 -1741.64)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1077",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1077",
    d: "M701.326,1846.2l-.226.513a8.087,8.087,0,0,0,1.714,1.355.036.036,0,0,1,.021.01v-.708l-.062-.031A6.862,6.862,0,0,1,701.326,1846.2Z",
    transform: "translate(-693.72 -1827.787)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1078",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1078",
    d: "M700.757,1777.821l-.246-.811a1.309,1.309,0,0,0-.195-.01,1.392,1.392,0,0,0-.616.144l.452.78A1.1,1.1,0,0,1,700.757,1777.821Z",
    transform: "translate(-692.464 -1765.689)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1079",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1079",
    d: "M673.481,1725.531l-.246-.811c-.144-.01-.3-.021-.441-.021a3.592,3.592,0,0,0-1.693.411l.452.78A3.367,3.367,0,0,1,673.481,1725.531Z",
    transform: "translate(-666.799 -1718.757)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1080",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1080",
    d: "M696.273,1769.121l-.246-.811a1.9,1.9,0,0,0-.236-.01,1.692,1.692,0,0,0-.79.185l.452.78A1.548,1.548,0,0,1,696.273,1769.121Z",
    transform: "translate(-688.247 -1757.882)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1081",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1081",
    d: "M728.941,1843.875H728.9l.246.821a1.679,1.679,0,0,0,.965-.215h.01l-.452-.78h-.01A1.489,1.489,0,0,1,728.941,1843.875Z",
    transform: "translate(-718.667 -1825.544)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1082",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1082",
    d: "M677.9,1788.4a7,7,0,0,0,.328,1.96l.554.051a6.034,6.034,0,0,1-.267-1.663Z",
    transform: "translate(-672.902 -1775.919)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1083",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1083",
    d: "M698.726,1852l-.226.513a9.277,9.277,0,0,0,1.971,1.56.036.036,0,0,1,.021.01v-.708l-.062-.031A8.6,8.6,0,0,1,698.726,1852Z",
    transform: "translate(-691.387 -1832.992)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1084",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1084",
    d: "M731.682,1852.126H731.6l.246.821a2.107,2.107,0,0,0,1.191-.267h.01l-.452-.78h-.01A1.9,1.9,0,0,1,731.682,1852.126Z",
    transform: "translate(-721.09 -1832.902)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1085",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1085",
    d: "M691.7,1760.331l-.246-.811a2.52,2.52,0,0,0-.277-.021,2.1,2.1,0,0,0-.975.226l.452.78A2.054,2.054,0,0,1,691.7,1760.331Z",
    transform: "translate(-683.939 -1749.986)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1086",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1086",
    d: "M726.4,1835.433l.246.821a1.418,1.418,0,0,0,.749-.175h.01l-.452-.78h-.01A1.1,1.1,0,0,1,726.4,1835.433Z",
    transform: "translate(-716.424 -1818.006)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1087",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1087",
    d: "M706.257,1795.233a.674.674,0,0,0-.257.277l1.057,1.109-.8-1.386Z",
    transform: "translate(-698.117 -1782.044)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1088",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1088",
    d: "M718.7,1851.008a3.843,3.843,0,0,0,1.488.493l-.246-.811a3.272,3.272,0,0,1-1.242-.39Z",
    transform: "translate(-709.514 -1831.466)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1089",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1089",
    d: "M659.748,1699.341l-.246-.811a5.175,5.175,0,0,0-.564-.031,4.577,4.577,0,0,0-2.237.554l.452.78A4.422,4.422,0,0,1,659.748,1699.341Z",
    transform: "translate(-653.878 -1695.246)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1090",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1090",
    d: "M706.426,1834.7l-.226.513a5.612,5.612,0,0,0,1.191.934.036.036,0,0,1,.021.01v-.708l-.062-.031A4.316,4.316,0,0,1,706.426,1834.7Z",
    transform: "translate(-698.297 -1817.467)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1091",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1091",
    d: "M700.752,1787.69h0l-.441-.79h-.01a1.012,1.012,0,0,0-.4.452l.585.616A.693.693,0,0,1,700.752,1787.69Z",
    transform: "translate(-692.644 -1774.573)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1092",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1092",
    d: "M668.807,1716.831l-.246-.811a3.8,3.8,0,0,0-.482-.021,3.857,3.857,0,0,0-1.878.462l.452.78A3.726,3.726,0,0,1,668.807,1716.831Z",
    transform: "translate(-662.402 -1710.95)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1093",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1093",
    d: "M718.7,1734.6v.708a10.864,10.864,0,0,1,2.268,1.847l.226-.513A12.165,12.165,0,0,0,718.7,1734.6Z",
    transform: "translate(-709.514 -1727.641)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1094",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1094",
    d: "M734.413,1860.467H734.3l.246.821a2.477,2.477,0,0,0,1.406-.308h.01l-.452-.78h-.01A2.306,2.306,0,0,1,734.413,1860.467Z",
    transform: "translate(-723.513 -1840.35)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1095",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1095",
    d: "M718.7,1742.4v.708a9.311,9.311,0,0,1,2,1.642l.226-.513A10.924,10.924,0,0,0,718.7,1742.4Z",
    transform: "translate(-709.514 -1734.641)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1096",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1096",
    d: "M703.826,1840.5l-.226.513a6.483,6.483,0,0,0,1.447,1.139.036.036,0,0,1,.021.01v-.708l-.062-.031A6.149,6.149,0,0,1,703.826,1840.5Z",
    transform: "translate(-695.964 -1822.672)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1097",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1097",
    d: "M664.323,1708.042l-.246-.811a4.481,4.481,0,0,0-.523-.031,4.308,4.308,0,0,0-2.053.5l.452.78A4.159,4.159,0,0,1,664.323,1708.042Z",
    transform: "translate(-658.185 -1703.053)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1098",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1098",
    d: "M718.7,1843.208a3.1,3.1,0,0,0,1.221.4l-.246-.811a2.522,2.522,0,0,1-.975-.3Z",
    transform: "translate(-709.514 -1824.467)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1099",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1099",
    d: "M707.042,1769.69v-.708c-.021-.01-.041-.031-.062-.041a3.568,3.568,0,0,0-1.18-.441l.246.811a2.7,2.7,0,0,1,.975.359C707.032,1769.68,707.042,1769.68,707.042,1769.69Z",
    transform: "translate(-697.938 -1758.062)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1100",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1100",
    d: "M718.7,1797v1.283l.4-.914A2.248,2.248,0,0,0,718.7,1797Z",
    transform: "translate(-709.514 -1783.637)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1101",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1101",
    d: "M714.069,1794.854a1.78,1.78,0,0,0-.369-.154l.431,1.437v-1.252Z",
    transform: "translate(-705.027 -1781.573)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1102",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1102",
    d: "M711.708,1787v-.708c-.021-.01-.041-.031-.062-.041A1.816,1.816,0,0,0,711,1786l.246.811a1.491,1.491,0,0,1,.431.164C711.7,1786.985,711.708,1786.985,711.708,1787Z",
    transform: "translate(-702.604 -1773.766)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1103",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1103",
    d: "M718.7,1758v.708a7.13,7.13,0,0,1,1.488,1.221l.226-.513A8.431,8.431,0,0,0,718.7,1758Z",
    transform: "translate(-709.514 -1748.64)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1104",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1104",
    d: "M696.226,1857.7l-.226.513a10.319,10.319,0,0,0,2.237,1.776.036.036,0,0,1,.021.01v-.708l-.062-.031A9.023,9.023,0,0,1,696.226,1857.7Z",
    transform: "translate(-689.144 -1838.107)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1105",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1105",
    d: "M709.375,1778.388v-.708c-.021-.01-.041-.031-.062-.041a2.566,2.566,0,0,0-.913-.339l.246.811a1.954,1.954,0,0,1,.708.267C709.365,1778.378,709.375,1778.378,709.375,1778.388Z",
    transform: "translate(-700.271 -1765.958)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1106",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1106",
    d: "M718.7,1773.6v.708a5,5,0,0,1,.965.8l.226-.513A6.324,6.324,0,0,0,718.7,1773.6Z",
    transform: "translate(-709.514 -1762.638)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1107",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1107",
    d: "M718.7,1781.4v.708a3.708,3.708,0,0,1,.7.585l.226-.513A4.661,4.661,0,0,0,718.7,1781.4Z",
    transform: "translate(-709.514 -1769.638)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1108",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1108",
    d: "M718.7,1827.608a1.913,1.913,0,0,0,.677.216l-.246-.811a1.17,1.17,0,0,1-.431-.113Z",
    transform: "translate(-709.514 -1810.468)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1109",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1109",
    d: "M708.926,1828.9l-.226.513a5.04,5.04,0,0,0,.924.729.036.036,0,0,1,.021.01v-.708l-.062-.031A3.355,3.355,0,0,1,708.926,1828.9Z",
    transform: "translate(-700.54 -1812.263)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1110",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1110",
    d: "M718.7,1835.408a2.651,2.651,0,0,0,.955.308l-.246-.811a1.779,1.779,0,0,1-.708-.205Z",
    transform: "translate(-709.514 -1817.467)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1111",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1111",
    d: "M718.7,1789.2v.708a2.48,2.48,0,0,1,.441.38l.226-.513A3.479,3.479,0,0,0,718.7,1789.2Z",
    transform: "translate(-709.514 -1776.637)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1112",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1112",
    d: "M719.111,1815.165l-.411-1.365v1.242A1.1,1.1,0,0,0,719.111,1815.165Z",
    transform: "translate(-709.514 -1798.712)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1113",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1113",
    d: "M690.53,1709.437v-.708c-.021-.01-.041-.031-.062-.041a7.921,7.921,0,0,0-3.069-1.088l.246.811a7.371,7.371,0,0,1,2.864,1.016C690.52,1709.427,690.53,1709.427,690.53,1709.437Z",
    transform: "translate(-681.427 -1703.412)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1114",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1114",
    d: "M709.546,1794.4a.621.621,0,0,0-.246.051l.79,1.375-.421-1.406A.516.516,0,0,0,709.546,1794.4Z",
    transform: "translate(-701.079 -1781.304)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1115",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1115",
    d: "M692.864,1718.045v-.708c-.021-.01-.041-.031-.062-.041a7.337,7.337,0,0,0-2.8-1l.246.811a6.835,6.835,0,0,1,2.586.913C692.853,1718.035,692.864,1718.035,692.864,1718.045Z",
    transform: "translate(-683.76 -1711.22)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1116",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1116",
    d: "M705.331,1786.621l-.246-.811a.777.777,0,0,0-.154-.01,1.017,1.017,0,0,0-.431.092l.452.78A.676.676,0,0,1,705.331,1786.621Z",
    transform: "translate(-696.771 -1773.586)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1117",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1117",
    d: "M695.286,1726.652v-.708c-.021-.01-.041-.031-.062-.041a6.605,6.605,0,0,0-2.525-.9l.246.811a6.146,6.146,0,0,1,2.32.821C695.276,1726.642,695.286,1726.642,695.286,1726.652Z",
    transform: "translate(-686.183 -1719.026)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1118",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1118",
    d: "M693.626,1863.5l-.226.513a11.2,11.2,0,0,0,2.494,1.981.036.036,0,0,1,.021.01v-.708l-.062-.031A10.719,10.719,0,0,1,693.626,1863.5Z",
    transform: "translate(-686.811 -1843.311)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1119",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1119",
    d: "M697.62,1735.26v-.708c-.021-.01-.041-.031-.062-.041a6.03,6.03,0,0,0-2.258-.811l.246.811a5.391,5.391,0,0,1,2.053.729C697.609,1735.25,697.62,1735.25,697.62,1735.26Z",
    transform: "translate(-688.516 -1726.834)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1120",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1120",
    d: "M704.709,1761.083v-.708c-.021-.01-.041-.031-.062-.041a4.106,4.106,0,0,0-1.447-.534l.246.811a3.458,3.458,0,0,1,1.242.452C704.7,1761.073,704.709,1761.073,704.709,1761.083Z",
    transform: "translate(-695.605 -1750.255)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1121",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1121",
    d: "M702.286,1752.475v-.708c-.021-.01-.041-.031-.062-.041a4.646,4.646,0,0,0-1.724-.626l.246.811a4.132,4.132,0,0,1,1.519.544C702.276,1752.465,702.286,1752.465,702.286,1752.475Z",
    transform: "translate(-693.182 -1742.448)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1122",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1122",
    d: "M688.526,1875l-.226.513a13.975,13.975,0,0,0,3.018,2.4.036.036,0,0,1,.021.01v-.708l-.062-.031A13.272,13.272,0,0,1,688.526,1875Z",
    transform: "translate(-682.234 -1853.631)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1123",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1123",
    d: "M691.126,1869.2l-.226.513a13,13,0,0,0,2.751,2.2.036.036,0,0,1,.021.01v-.708l-.062-.031A12.032,12.032,0,0,1,691.126,1869.2Z",
    transform: "translate(-684.567 -1848.426)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1124",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1124",
    d: "M699.953,1743.868v-.708c-.021-.01-.041-.031-.062-.041a5.463,5.463,0,0,0-1.991-.719l.246.811a4.82,4.82,0,0,1,1.786.636C699.943,1743.857,699.953,1743.857,699.953,1743.868Z",
    transform: "translate(-690.849 -1734.641)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1125",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1125",
    d: "M682.314,1762.89h0l-.441-.79h-.01a2.115,2.115,0,0,0-.862.975l.585.616A1.906,1.906,0,0,1,682.314,1762.89Z",
    transform: "translate(-675.683 -1752.319)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1126",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1126",
    d: "M743.7,1758.066a16.121,16.121,0,0,0-2.176-2.966l-.226.513a14.522,14.522,0,0,1,1.981,2.7Z",
    transform: "translate(-729.794 -1746.037)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1127",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1127",
    d: "M664.79,1759.3a5.186,5.186,0,0,0-.39,2.094l.616.359a4.723,4.723,0,0,1,.359-1.837Z",
    transform: "translate(-660.787 -1749.806)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1128",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1128",
    d: "M746.527,1752.674a17.934,17.934,0,0,0-2.4-3.274l-.226.513a16.225,16.225,0,0,1,2.207,3.007Z",
    transform: "translate(-732.128 -1740.922)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1129",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1129",
    d: "M658.041,1752.8a6.092,6.092,0,0,0-.441,2.361l.616.359a5.318,5.318,0,0,1,.411-2.114Z",
    transform: "translate(-654.685 -1743.973)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1130",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1130",
    d: "M740.976,1763.558a14.413,14.413,0,0,0-1.95-2.658l-.226.513a12.776,12.776,0,0,1,1.745,2.391Z",
    transform: "translate(-727.551 -1751.242)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1131",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1131",
    d: "M651.393,1746.2a6.793,6.793,0,0,0-.493,2.638l.616.359a6.154,6.154,0,0,1,.452-2.381Z",
    transform: "translate(-648.673 -1738.051)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1132",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1132",
    d: "M735.414,1774.443a10.964,10.964,0,0,0-1.488-2.042l-.226.513a9.843,9.843,0,0,1,1.293,1.776Z",
    transform: "translate(-722.974 -1761.562)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1133",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1133",
    d: "M678.187,1772.4a3.94,3.94,0,0,0-.287,1.55l.616.359a3.3,3.3,0,0,1,.257-1.293Z",
    transform: "translate(-672.902 -1761.562)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1134",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1134",
    d: "M752.089,1741.79a20.918,20.918,0,0,0-2.864-3.89l-.226.513a19.323,19.323,0,0,1,2.669,3.623Z",
    transform: "translate(-736.704 -1730.602)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1135",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1135",
    d: "M718.7,1874.408a5.744,5.744,0,0,0,2.3.77l-.246-.811a5.217,5.217,0,0,1-2.053-.667Z",
    transform: "translate(-709.514 -1852.464)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1136",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1136",
    d: "M749.353,1747.182a19.641,19.641,0,0,0-2.627-3.582l-.226.513a17.582,17.582,0,0,1,2.432,3.315Z",
    transform: "translate(-734.461 -1735.717)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1137",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1137",
    d: "M671.539,1765.9a4.627,4.627,0,0,0-.339,1.817l.616.359a3.943,3.943,0,0,1,.308-1.56Z",
    transform: "translate(-666.889 -1755.729)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1138",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1138",
    d: "M718.7,1897.808a7.7,7.7,0,0,0,3.11,1.047l-.246-.811a7.219,7.219,0,0,1-2.864-.944Z",
    transform: "translate(-709.514 -1873.463)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1139",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1139",
    d: "M698.2,1800.1a3.377,3.377,0,0,0,.164.934l.554.051a2.352,2.352,0,0,1-.1-.636Z",
    transform: "translate(-691.118 -1786.418)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1140",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1140",
    d: "M718.7,1882.208a6.486,6.486,0,0,0,2.566.862l-.246-.811a5.961,5.961,0,0,1-2.32-.76Z",
    transform: "translate(-709.514 -1859.464)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1141",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1141",
    d: "M738.24,1768.95a13.147,13.147,0,0,0-1.714-2.35l-.226.513a11.081,11.081,0,0,1,1.519,2.084Z",
    transform: "translate(-725.308 -1756.357)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1142",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1142",
    d: "M644.644,1739.7a7.533,7.533,0,0,0-.544,2.915l.616.359a6.9,6.9,0,0,1,.5-2.658Z",
    transform: "translate(-642.571 -1732.218)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1143",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1143",
    d: "M718.61,1890.008a7.29,7.29,0,0,0,2.833.954l-.246-.811a6.472,6.472,0,0,1-2.6-.852Z",
    transform: "translate(-709.424 -1866.463)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1144",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1144",
    d: "M691.4,1796.2a4.866,4.866,0,0,0,.216,1.283l.554.051a3.272,3.272,0,0,1-.154-.975Z",
    transform: "translate(-685.016 -1782.919)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1145",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1145",
    d: "M714.111,1814.273a.036.036,0,0,1,.021.01V1813l-.431.965A1.866,1.866,0,0,0,714.111,1814.273Z",
    transform: "translate(-705.027 -1797.995)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1146",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1146",
    d: "M638,1733.1a8.259,8.259,0,0,0-.6,3.182l.616.359a7.394,7.394,0,0,1,.554-2.925Z",
    transform: "translate(-636.558 -1726.295)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1147",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1147",
    d: "M705.1,1804.6l1.1.1-1.2-.7A2.071,2.071,0,0,0,705.1,1804.6Z",
    transform: "translate(-697.22 -1789.918)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1148",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1148",
    d: "M631.336,1726.6a8.6,8.6,0,0,0-.636,3.459l.616.359a8.17,8.17,0,0,1,.606-3.2Z",
    transform: "translate(-630.546 -1720.462)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1149",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1149",
    d: "M718.7,1719v.708a13.346,13.346,0,0,1,2.792,2.268l.226-.513A14.318,14.318,0,0,0,718.7,1719Z",
    transform: "translate(-709.514 -1713.642)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1150",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1150",
    d: "M670.122,1746.39h0l-.441-.79h-.01a2.934,2.934,0,0,0-1.17,1.334l.585.616A2.606,2.606,0,0,1,670.122,1746.39Z",
    transform: "translate(-664.466 -1737.512)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1151",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1151",
    d: "M676.268,1754.59h0l-.441-.79h-.01a2.533,2.533,0,0,0-1.016,1.149l.585.616A2.264,2.264,0,0,1,676.268,1754.59Z",
    transform: "translate(-670.12 -1744.871)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1152",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1152",
    d: "M718.61,1858.808a4.594,4.594,0,0,0,1.755.585l-.246-.811a3.775,3.775,0,0,1-1.519-.482Z",
    transform: "translate(-709.424 -1838.466)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1153",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1153",
    d: "M663.976,1738.09h0l-.441-.79h-.01a3.244,3.244,0,0,0-1.324,1.509l.585.616A2.968,2.968,0,0,1,663.976,1738.09Z",
    transform: "translate(-658.813 -1730.064)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1154",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1154",
    d: "M718.7,1866.608a5.158,5.158,0,0,0,2.032.677l-.246-.811a4.522,4.522,0,0,1-1.786-.575Z",
    transform: "translate(-709.514 -1845.465)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1155",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1155",
    d: "M651.873,1721.49h0l-.441-.79h-.01a3.956,3.956,0,0,0-1.622,1.858l.585.616A3.73,3.73,0,0,1,651.873,1721.49Z",
    transform: "translate(-647.686 -1715.168)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1156",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1156",
    d: "M684.936,1779a3.2,3.2,0,0,0-.236,1.273l.616.359a2.521,2.521,0,0,1,.205-1.016Z",
    transform: "translate(-679.004 -1767.484)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1157",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1157",
    d: "M684.7,1792.3a6.087,6.087,0,0,0,.267,1.622l.554.051a5.017,5.017,0,0,1-.216-1.314Z",
    transform: "translate(-679.004 -1779.419)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1158",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1158",
    d: "M718.7,1726.8v.708a11.784,11.784,0,0,1,2.525,2.063l.226-.513A13.075,13.075,0,0,0,718.7,1726.8Z",
    transform: "translate(-709.514 -1720.642)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1159",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1159",
    d: "M688.46,1771.19h0l-.441-.79h-.01a1.746,1.746,0,0,0-.708.8l.585.616A1.421,1.421,0,0,1,688.46,1771.19Z",
    transform: "translate(-681.337 -1759.767)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1160",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1160",
    d: "M718.7,1765.8v.708a6.175,6.175,0,0,1,1.221,1.006l.226-.513A7.5,7.5,0,0,0,718.7,1765.8Z",
    transform: "translate(-709.514 -1755.639)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1161",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1161",
    d: "M723.7,1827.092l.246.821a1,1,0,0,0,.523-.133h.01l-.452-.78h-.01A.643.643,0,0,1,723.7,1827.092Z",
    transform: "translate(-714.001 -1810.558)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1162",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1162",
    d: "M657.919,1729.79h0l-.441-.79h-.01a3.643,3.643,0,0,0-1.468,1.683l.585.616A3.367,3.367,0,0,1,657.919,1729.79Z",
    transform: "translate(-653.249 -1722.616)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1163",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1163",
    d: "M698.333,1792.1a1.965,1.965,0,0,0-.133.729l.616.359a1.281,1.281,0,0,1,.1-.472Z",
    transform: "translate(-691.118 -1779.24)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1164",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1164",
    d: "M694.606,1779.39h0l-.441-.79h-.01a1.328,1.328,0,0,0-.554.626l.585.616A1.19,1.19,0,0,1,694.606,1779.39Z",
    transform: "translate(-686.99 -1767.125)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1165",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1165",
    d: "M711.526,1823.2l-.226.513a3.134,3.134,0,0,0,.667.513.036.036,0,0,1,.021.01v-.719l-.062-.031A1.793,1.793,0,0,1,711.526,1823.2Z",
    transform: "translate(-702.874 -1807.148)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1166",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1166",
    d: "M691.585,1785.5a2.48,2.48,0,0,0-.185,1.006l.616.359a2.067,2.067,0,0,1,.154-.749Z",
    transform: "translate(-685.016 -1773.317)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1167",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1167",
    d: "M704.9,1799.062l1.16.667-1.078-1.129A1.545,1.545,0,0,0,704.9,1799.062Z",
    transform: "translate(-697.13 -1785.073)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1168",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1168",
    d: "M639.581,1704.99h0l-.441-.79h-.01a4.692,4.692,0,0,0-1.93,2.207l.585.616A4.413,4.413,0,0,1,639.581,1704.99Z",
    transform: "translate(-636.379 -1700.361)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1169",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1169",
    d: "M645.727,1713.29h0l-.441-.79h-.01a4.379,4.379,0,0,0-1.776,2.032l.585.616A4.1,4.1,0,0,1,645.727,1713.29Z",
    transform: "translate(-642.032 -1707.81)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1170",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1170",
    d: "M720.308,1815.542h0l-.708-1.242.4,1.324A.761.761,0,0,0,720.308,1815.542Z",
    transform: "translate(-710.322 -1799.161)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1171",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1171",
    d: "M633.435,1696.69h0l-.441-.79h-.01a5.142,5.142,0,0,0-2.083,2.392l.585.616A4.864,4.864,0,0,1,633.435,1696.69Z",
    transform: "translate(-630.726 -1692.913)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1172",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1172",
    d: "M727.3,1806.875a3.091,3.091,0,0,0-.236-.575l-.062.041a2.822,2.822,0,0,1,.216.523Z",
    transform: "translate(-716.962 -1791.982)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1173",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1173",
    d: "M718.7,1825.992a1.038,1.038,0,0,0,.431.113l-.021-.082a1.1,1.1,0,0,1-.411-.123Z",
    transform: "translate(-709.514 -1809.571)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1174",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1174",
    d: "M723.5,1826.482l.021.072a.754.754,0,0,0,.328-.092h.01l-.041-.062h-.01A.761.761,0,0,1,723.5,1826.482Z",
    transform: "translate(-713.821 -1810.019)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1175",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1175",
    d: "M713.531,1822.5l-.031.072a2.247,2.247,0,0,0,.4.3l.062.031v-.092a.036.036,0,0,1-.021-.01A1.681,1.681,0,0,1,713.531,1822.5Z",
    transform: "translate(-704.848 -1806.52)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1176",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1176",
    d: "M723.611,1800.944a3.423,3.423,0,0,0-.38-.544l-.031.072a2.921,2.921,0,0,1,.349.5Z",
    transform: "translate(-713.552 -1786.688)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1177",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1177",
    d: "M713.952,1794.267v-.092a.036.036,0,0,1-.021-.01,1.41,1.41,0,0,0-.431-.164l.021.082a1.136,1.136,0,0,1,.37.154A.089.089,0,0,1,713.952,1794.267Z",
    transform: "translate(-704.848 -1780.945)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1178",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1178",
    d: "M709.4,1793.751l-.021-.082a.778.778,0,0,0-.38.051l.041.062a.7.7,0,0,1,.246-.051A.37.37,0,0,0,709.4,1793.751Z",
    transform: "translate(-700.81 -1780.644)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1179",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1179",
    d: "M705.808,1794.672h0l-.031-.072h-.01a.694.694,0,0,0-.267.277l.051.062A.8.8,0,0,1,705.808,1794.672Z",
    transform: "translate(-697.669 -1781.483)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1180",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1180",
    d: "M727.367,1823.262l-.062-.062a.813.813,0,0,1-.205.277l.041.072A.761.761,0,0,0,727.367,1823.262Z",
    transform: "translate(-717.052 -1807.148)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1181",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1181",
    d: "M718.7,1796.1v.092a2.641,2.641,0,0,1,.4.359l.031-.072A2.489,2.489,0,0,0,718.7,1796.1Z",
    transform: "translate(-709.514 -1782.829)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1182",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1182",
    d: "M705.4,1810.5a3.909,3.909,0,0,0,.287.636l.062-.041a3.364,3.364,0,0,1-.277-.585Z",
    transform: "translate(-697.579 -1795.751)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1183",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1183",
    d: "M704.3,1798.1a1.33,1.33,0,0,0-.1.472l.072.041a1.279,1.279,0,0,1,.082-.462Z",
    transform: "translate(-696.502 -1784.624)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1184",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1184",
    d: "M708.6,1816.941a2.871,2.871,0,0,0,.431.544l.031-.072a3.278,3.278,0,0,1-.4-.513Z",
    transform: "translate(-700.451 -1801.494)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1185",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1185",
    d: "M704.2,1803.5a2.348,2.348,0,0,0,.1.636l.082.01a2.074,2.074,0,0,1-.1-.6Z",
    transform: "translate(-696.502 -1789.47)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1186",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1186",
    d: "M729.364,1813.165a2.2,2.2,0,0,0-.082-.554l-.082-.01a2.322,2.322,0,0,1,.082.513Z",
    transform: "translate(-718.936 -1797.636)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1187",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1187",
    d: "M729.651,1818.962a1.7,1.7,0,0,0,.082-.421l-.072-.041a1.174,1.174,0,0,1-.062.4Z",
    transform: "translate(-719.295 -1802.93)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1188",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1188",
    d: "M710.931,1828.2l-.031.072a3.35,3.35,0,0,0,.657.513l.062.031v-.092a.036.036,0,0,1-.021-.01A3.415,3.415,0,0,1,710.931,1828.2Z",
    transform: "translate(-702.515 -1811.634)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1189",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1189",
    d: "M704.726,1785.028l-.021-.082a1.2,1.2,0,0,0-.606.092l.041.072a1.017,1.017,0,0,1,.431-.092C704.623,1785.018,704.675,1785.028,704.726,1785.028Z",
    transform: "translate(-696.412 -1772.815)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1190",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1190",
    d: "M699.762,1786.372h0l-.031-.072h-.01a1.12,1.12,0,0,0-.421.452l.062.062A1.042,1.042,0,0,1,699.762,1786.372Z",
    transform: "translate(-692.105 -1774.035)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1191",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1191",
    d: "M711.529,1785.57v-.092a.036.036,0,0,1-.021-.01,2.165,2.165,0,0,0-.708-.267l.021.082a2.3,2.3,0,0,1,.647.246A.214.214,0,0,1,711.529,1785.57Z",
    transform: "translate(-702.425 -1773.048)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1192",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1192",
    d: "M726.1,1834.734l.021.082a1.1,1.1,0,0,0,.544-.144h.01l-.041-.072h-.01A1,1,0,0,1,726.1,1834.734Z",
    transform: "translate(-716.154 -1817.378)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1193",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1193",
    d: "M735.716,1814.1a3.487,3.487,0,0,0-.133-.893l-.082-.01a3.134,3.134,0,0,1,.133.852Z",
    transform: "translate(-724.59 -1798.174)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1194",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1194",
    d: "M699.2,1809.9a4.6,4.6,0,0,0,.441.975l.062-.041a4.659,4.659,0,0,1-.421-.924Z",
    transform: "translate(-692.015 -1795.213)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1195",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1195",
    d: "M732.321,1829.762l-.062-.062a1.054,1.054,0,0,1-.359.452l.041.072A1.128,1.128,0,0,0,732.321,1829.762Z",
    transform: "translate(-721.359 -1812.981)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1196",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1196",
    d: "M718.7,1833.792a1.777,1.777,0,0,0,.708.205l-.021-.082a1.856,1.856,0,0,1-.677-.216v.092Z",
    transform: "translate(-709.514 -1816.57)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1197",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1197",
    d: "M732.152,1804.513a4.707,4.707,0,0,0-.39-.913l-.062.041a4.632,4.632,0,0,1,.369.872Z",
    transform: "translate(-721.18 -1789.559)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1198",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1198",
    d: "M718.7,1788.3v.092a3.489,3.489,0,0,1,.667.575l.031-.072A3.771,3.771,0,0,0,718.7,1788.3Z",
    transform: "translate(-709.514 -1775.83)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1199",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1199",
    d: "M735.851,1823.139a2.013,2.013,0,0,0,.133-.7l-.072-.041a1.95,1.95,0,0,1-.113.677Z",
    transform: "translate(-724.859 -1806.43)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1200",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1200",
    d: "M697.4,1799.7a3.639,3.639,0,0,0,.154.975l.082.01a3.886,3.886,0,0,1-.164-.934Z",
    transform: "translate(-690.4 -1786.06)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1201",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1201",
    d: "M697.554,1791.5a2.021,2.021,0,0,0-.154.749l.072.041a1.965,1.965,0,0,1,.133-.729Z",
    transform: "translate(-690.4 -1778.701)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1202",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1202",
    d: "M726.436,1795.452a5.1,5.1,0,0,0-.605-.852l-.031.072a4.616,4.616,0,0,1,.575.811Z",
    transform: "translate(-715.885 -1781.483)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1203",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1203",
    d: "M703.9,1819.641a4.219,4.219,0,0,0,.667.852l.031-.072a4.137,4.137,0,0,1-.626-.821Z",
    transform: "translate(-696.233 -1803.917)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1204",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1204",
    d: "M728.8,1843.074l.021.072h.041a1.451,1.451,0,0,0,.729-.185h.01l-.041-.062h-.01A1.443,1.443,0,0,1,728.8,1843.074Z",
    transform: "translate(-718.577 -1824.826)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1205",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1205",
    d: "M699.1,1822.441a5.9,5.9,0,0,0,.893,1.16l.031-.072a6.307,6.307,0,0,1-.862-1.129Z",
    transform: "translate(-691.926 -1806.43)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1206",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1206",
    d: "M709.2,1776.862v-.092a.036.036,0,0,1-.021-.01,2.7,2.7,0,0,0-.975-.359l.021.082a2.777,2.777,0,0,1,.913.339A.215.215,0,0,0,709.2,1776.862Z",
    transform: "translate(-700.092 -1765.151)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1207",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1207",
    d: "M737.1,1802.152a5.824,5.824,0,0,0-.534-1.252l-.062.041a6.212,6.212,0,0,1,.513,1.211Z",
    transform: "translate(-725.487 -1787.136)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1208",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1208",
    d: "M693.616,1778.072h0l-.031-.072h-.01a1.447,1.447,0,0,0-.575.636l.062.062A1.379,1.379,0,0,1,693.616,1778.072Z",
    transform: "translate(-686.452 -1766.587)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1209",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1209",
    d: "M708.431,1834l-.031.072a4.318,4.318,0,0,0,.924.719l.062.031v-.092a.036.036,0,0,1-.021-.01A4.132,4.132,0,0,1,708.431,1834Z",
    transform: "translate(-700.271 -1816.839)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1210",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1210",
    d: "M718.7,1780.5v.092a4.4,4.4,0,0,1,.924.79l.031-.072A4.4,4.4,0,0,0,718.7,1780.5Z",
    transform: "translate(-709.514 -1768.83)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1211",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1211",
    d: "M700.242,1776.305l-.021-.082a1.562,1.562,0,0,0-.821.133l.041.072a1.36,1.36,0,0,1,.616-.144A1.006,1.006,0,0,0,700.242,1776.305Z",
    transform: "translate(-692.195 -1764.984)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1212",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1212",
    d: "M742.151,1827.306a2.737,2.737,0,0,0,.185-.965l-.072-.041a2.732,2.732,0,0,1-.164.954Z",
    transform: "translate(-730.512 -1809.93)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1213",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1213",
    d: "M693,1809.3a6.5,6.5,0,0,0,.585,1.314l.062-.041a6.449,6.449,0,0,1-.575-1.273Z",
    transform: "translate(-686.452 -1794.674)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1214",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1214",
    d: "M742.067,1815.042a4.716,4.716,0,0,0-.185-1.232l-.082-.01a4.968,4.968,0,0,1,.2,1.2Z",
    transform: "translate(-730.243 -1798.713)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1215",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1215",
    d: "M737.275,1836.362l-.062-.062a1.416,1.416,0,0,1-.513.626l.041.062A1.456,1.456,0,0,0,737.275,1836.362Z",
    transform: "translate(-725.667 -1818.903)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1216",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1216",
    d: "M729.162,1790.06a6.792,6.792,0,0,0-.831-1.16l-.031.072a6.717,6.717,0,0,1,.8,1.119Z",
    transform: "translate(-718.129 -1776.368)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1217",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1217",
    d: "M690.905,1785a2.75,2.75,0,0,0-.205,1.016l.072.041a2.514,2.514,0,0,1,.185-1.006Z",
    transform: "translate(-684.388 -1772.868)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1218",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1218",
    d: "M690.7,1795.8a4.625,4.625,0,0,0,.216,1.314l.082.01a4.731,4.731,0,0,1-.216-1.283Z",
    transform: "translate(-684.388 -1782.56)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1219",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1219",
    d: "M718.7,1841.592a2.525,2.525,0,0,0,.975.3l-.021-.082a2.349,2.349,0,0,1-.954-.308Z",
    transform: "translate(-709.514 -1823.569)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1220",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1220",
    d: "M683.9,1791.9a5.674,5.674,0,0,0,.267,1.663l.082.01a6.08,6.08,0,0,1-.267-1.622Z",
    transform: "translate(-678.286 -1779.06)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1221",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1221",
    d: "M684.157,1778.4a3.3,3.3,0,0,0-.257,1.293l.072.041a3.166,3.166,0,0,1,.236-1.273Z",
    transform: "translate(-678.286 -1766.946)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1222",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1222",
    d: "M706.862,1768.254v-.092a.036.036,0,0,1-.021-.01,3.46,3.46,0,0,0-1.242-.452l.021.082a3.167,3.167,0,0,1,1.18.441Z",
    transform: "translate(-697.759 -1757.344)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1223",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1223",
    d: "M718.7,1772.7v.092a6.33,6.33,0,0,1,1.191,1l.031-.072A6.236,6.236,0,0,0,718.7,1772.7Z",
    transform: "translate(-709.514 -1761.831)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1224",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1224",
    d: "M687.47,1769.772h0l-.031-.072h-.01a1.874,1.874,0,0,0-.729.811l.062.062A1.8,1.8,0,0,1,687.47,1769.772Z",
    transform: "translate(-680.798 -1759.139)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1225",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1225",
    d: "M695.667,1767.574l-.021-.082a1.794,1.794,0,0,0-1.047.185l.041.062a1.694,1.694,0,0,1,.79-.185C695.5,1767.564,695.585,1767.564,695.667,1767.574Z",
    transform: "translate(-687.888 -1757.146)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1226",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1226",
    d: "M748.228,1815.891a5.753,5.753,0,0,0-.246-1.581l-.082-.01a5.931,5.931,0,0,1,.246,1.54Z",
    transform: "translate(-735.717 -1799.161)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1227",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1227",
    d: "M742.218,1842.962l-.062-.062a1.919,1.919,0,0,1-.657.811l.041.062A1.888,1.888,0,0,0,742.218,1842.962Z",
    transform: "translate(-729.974 -1824.826)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1228",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1228",
    d: "M731.9,1784.568a8.528,8.528,0,0,0-1.068-1.468l-.031.072a8.049,8.049,0,0,1,1.037,1.427Z",
    transform: "translate(-720.372 -1771.163)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1229",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1229",
    d: "M742.039,1799.691a8.618,8.618,0,0,0-.677-1.591l-.062.041a8.207,8.207,0,0,1,.667,1.55Z",
    transform: "translate(-729.794 -1784.624)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1230",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1230",
    d: "M718.7,1849.392a3.1,3.1,0,0,0,1.242.39l-.021-.082a3.094,3.094,0,0,1-1.221-.4Z",
    transform: "translate(-709.514 -1830.569)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1231",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1231",
    d: "M694.3,1825.141a7.924,7.924,0,0,0,1.119,1.468l.031-.072a7.557,7.557,0,0,1-1.088-1.437Z",
    transform: "translate(-687.618 -1808.853)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1232",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1232",
    d: "M748.262,1831.483a3.271,3.271,0,0,0,.226-1.242l-.072-.041a3.2,3.2,0,0,1-.216,1.221Z",
    transform: "translate(-735.986 -1813.429)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1233",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1233",
    d: "M705.831,1839.7l-.031.072a5.766,5.766,0,0,0,1.18.924l.062.031v-.092a.036.036,0,0,1-.021-.01A4.974,4.974,0,0,1,705.831,1839.7Z",
    transform: "translate(-697.938 -1821.954)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1234",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1234",
    d: "M686.8,1808.8a7.912,7.912,0,0,0,.739,1.652l.062-.041a8.055,8.055,0,0,1-.719-1.611Z",
    transform: "translate(-680.888 -1794.226)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1235",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1235",
    d: "M731.4,1851.416l.021.082h.082a1.8,1.8,0,0,0,.9-.236h.01l-.041-.062h-.01A1.718,1.718,0,0,1,731.4,1851.416Z",
    transform: "translate(-720.911 -1832.274)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1236",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1236",
    d: "M754.562,1835.75a3.956,3.956,0,0,0,.277-1.509l-.072-.041a3.909,3.909,0,0,1-.267,1.5Z",
    transform: "translate(-741.64 -1817.019)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1237",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1237",
    d: "M677.2,1788a6.95,6.95,0,0,0,.318,2l.082.01a7.128,7.128,0,0,1-.328-1.96Z",
    transform: "translate(-672.273 -1775.56)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1238",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1238",
    d: "M754.58,1816.83a7.1,7.1,0,0,0-.3-1.919l-.082-.01a6.815,6.815,0,0,1,.3,1.878Z",
    transform: "translate(-741.37 -1799.7)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1239",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1239",
    d: "M718.7,1857.192a3.679,3.679,0,0,0,1.519.482l-.021-.082a3.843,3.843,0,0,1-1.488-.493Z",
    transform: "translate(-709.514 -1837.568)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1240",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1240",
    d: "M747.172,1849.461l-.062-.062a2.211,2.211,0,0,1-.811.985l.041.062A2.194,2.194,0,0,0,747.172,1849.461Z",
    transform: "translate(-734.281 -1830.658)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1241",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1241",
    d: "M681.324,1761.572h0l-.031-.072h-.01a2.18,2.18,0,0,0-.883.985l.062.062A2.172,2.172,0,0,1,681.324,1761.572Z",
    transform: "translate(-675.145 -1751.78)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1242",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1242",
    d: "M703.331,1845.5l-.031.072a7.134,7.134,0,0,0,1.447,1.139l.062.031v-.092a.036.036,0,0,1-.021-.01A6.6,6.6,0,0,1,703.331,1845.5Z",
    transform: "translate(-695.695 -1827.159)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1243",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1243",
    d: "M734,1859.757l.021.082h.113a2.172,2.172,0,0,0,1.088-.277h.01l-.041-.062h-.01A2.135,2.135,0,0,1,734,1859.757Z",
    transform: "translate(-723.244 -1839.722)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1244",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1244",
    d: "M734.724,1779.176a9.714,9.714,0,0,0-1.293-1.776l-.031.072a9.754,9.754,0,0,1,1.262,1.735Z",
    transform: "translate(-722.705 -1766.048)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1245",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1245",
    d: "M746.893,1797.24a9.688,9.688,0,0,0-.831-1.94l-.062.041a9.788,9.788,0,0,1,.811,1.888Z",
    transform: "translate(-734.012 -1782.111)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1246",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1246",
    d: "M677.508,1771.9a3.982,3.982,0,0,0-.308,1.56l.072.041a3.94,3.94,0,0,1,.287-1.55Z",
    transform: "translate(-672.273 -1761.113)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1247",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1247",
    d: "M689.5,1827.941a9.66,9.66,0,0,0,1.355,1.776l.031-.072a9.251,9.251,0,0,1-1.314-1.745Z",
    transform: "translate(-683.311 -1811.365)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1248",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1248",
    d: "M704.44,1759.747v-.092a.036.036,0,0,1-.021-.01,4.01,4.01,0,0,0-1.519-.544l.021.082a3.913,3.913,0,0,1,1.447.534A.093.093,0,0,1,704.44,1759.747Z",
    transform: "translate(-695.336 -1749.627)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1249",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1249",
    d: "M680.5,1808.2a10.074,10.074,0,0,0,.883,1.991l.062-.041a10.309,10.309,0,0,1-.872-1.95Z",
    transform: "translate(-675.235 -1793.687)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1250",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1250",
    d: "M718.7,1764.9v.092a7.2,7.2,0,0,1,1.447,1.2l.031-.072A7.144,7.144,0,0,0,718.7,1764.9Z",
    transform: "translate(-709.514 -1754.831)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1251",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1251",
    d: "M691.183,1758.885l-.021-.082a2.25,2.25,0,0,0-1.262.226l.041.062a2.068,2.068,0,0,1,.975-.226C691,1758.874,691.091,1758.874,691.183,1758.885Z",
    transform: "translate(-683.67 -1749.35)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1252",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1252",
    d: "M686.609,1750.161l-.021-.082a2.673,2.673,0,0,0-1.488.267l.041.062a2.438,2.438,0,0,1,1.15-.277Z",
    transform: "translate(-679.363 -1741.519)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1253",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1253",
    d: "M736.6,1868.1l.021.082c.051,0,.1.01.154.01a2.554,2.554,0,0,0,1.273-.328h.01l-.041-.062h-.01A2.559,2.559,0,0,1,736.6,1868.1Z",
    transform: "translate(-725.577 -1847.17)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1254",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1254",
    d: "M670.4,1784.1a8.23,8.23,0,0,0,.37,2.34l.082.01a8.421,8.421,0,0,1-.38-2.309Z",
    transform: "translate(-666.171 -1772.061)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1255",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1255",
    d: "M674.3,1807.7a11,11,0,0,0,1.037,2.34l.062-.041a11.631,11.631,0,0,1-1.016-2.289Z",
    transform: "translate(-669.671 -1793.239)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1256",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1256",
    d: "M702.106,1751.139v-.093a.036.036,0,0,1-.021-.01,4.587,4.587,0,0,0-1.786-.636l.021.082a4.71,4.71,0,0,1,1.724.626A.088.088,0,0,1,702.106,1751.139Z",
    transform: "translate(-693.002 -1741.819)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1257",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1257",
    d: "M760.831,1817.768a8,8,0,0,0-.349-2.258l-.082-.01a8.194,8.194,0,0,1,.359,2.227Z",
    transform: "translate(-746.934 -1800.238)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1258",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1258",
    d: "M718.7,1864.992a4.471,4.471,0,0,0,1.786.575l-.021-.082a4.482,4.482,0,0,1-1.755-.585v.093Z",
    transform: "translate(-709.514 -1844.568)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1259",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1259",
    d: "M751.937,1794.879a11.626,11.626,0,0,0-.975-2.279l-.062.041a11.793,11.793,0,0,1,.965,2.227Z",
    transform: "translate(-738.409 -1779.688)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1260",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1260",
    d: "M670.759,1765.3a4.723,4.723,0,0,0-.359,1.837l.072.041a4.626,4.626,0,0,1,.339-1.817Z",
    transform: "translate(-666.171 -1755.19)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1261",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1261",
    d: "M737.55,1773.683a11.076,11.076,0,0,0-1.519-2.084l-.031.072a10.971,10.971,0,0,1,1.488,2.042Z",
    transform: "translate(-725.038 -1760.844)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1262",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1262",
    d: "M752.026,1856.062l-.062-.062a2.576,2.576,0,0,1-.965,1.16l.041.062A2.553,2.553,0,0,0,752.026,1856.062Z",
    transform: "translate(-738.499 -1836.581)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1263",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1263",
    d: "M760.862,1839.827a4.51,4.51,0,0,0,.328-1.786l-.072-.041a4.6,4.6,0,0,1-.318,1.765Z",
    transform: "translate(-747.293 -1820.429)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1264",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1264",
    d: "M700.731,1851.2l-.031.072a8.241,8.241,0,0,0,1.7,1.344l.062.031v-.092a.036.036,0,0,1-.021-.01A7.718,7.718,0,0,1,700.731,1851.2Z",
    transform: "translate(-693.361 -1832.274)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1265",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1265",
    d: "M675.278,1753.272h0l-.031-.072h-.01a2.662,2.662,0,0,0-1.037,1.16l.062.062A2.533,2.533,0,0,1,675.278,1753.272Z",
    transform: "translate(-669.581 -1744.332)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1266",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1266",
    d: "M684.8,1830.741a11.024,11.024,0,0,0,1.581,2.083l.031-.072a11,11,0,0,1-1.55-2.053Z",
    transform: "translate(-679.093 -1813.878)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1267",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1267",
    d: "M718.7,1757.1v.092a8.439,8.439,0,0,1,1.714,1.416l.031-.072A8.375,8.375,0,0,0,718.7,1757.1Z",
    transform: "translate(-709.514 -1747.832)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1268",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1268",
    d: "M682.024,1741.439l-.021-.082a2.961,2.961,0,0,0-1.7.318l.041.062a2.784,2.784,0,0,1,1.334-.318C681.788,1741.418,681.9,1741.428,682.024,1741.439Z",
    transform: "translate(-675.055 -1733.69)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1269",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1269",
    d: "M739.2,1876.439l.021.082c.062,0,.133.01.2.01a2.864,2.864,0,0,0,1.447-.37h.01l-.041-.062h-.01A2.825,2.825,0,0,1,739.2,1876.439Z",
    transform: "translate(-727.91 -1854.618)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1270",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1270",
    d: "M718.7,1872.792a5.215,5.215,0,0,0,2.053.667l-.021-.082a5,5,0,0,1-2.032-.677Z",
    transform: "translate(-709.514 -1851.567)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1271",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1271",
    d: "M756.98,1862.562l-.062-.062a2.89,2.89,0,0,1-1.119,1.334l.041.062A2.929,2.929,0,0,0,756.98,1862.562Z",
    transform: "translate(-742.806 -1842.414)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1272",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1272",
    d: "M680,1833.441a12.722,12.722,0,0,0,1.806,2.391l.031-.072a12.694,12.694,0,0,1-1.776-2.361Z",
    transform: "translate(-674.786 -1816.301)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1273",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1273",
    d: "M698.231,1857l-.031.072a9.266,9.266,0,0,0,1.971,1.56l.062.031v-.092a.036.036,0,0,1-.021-.01A9.078,9.078,0,0,1,698.231,1857Z",
    transform: "translate(-691.118 -1837.479)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1274",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1274",
    d: "M669.221,1744.972h0l-.031-.072h-.01a2.891,2.891,0,0,0-1.18,1.334l.062.062A2.875,2.875,0,0,1,669.221,1744.972Z",
    transform: "translate(-664.018 -1736.884)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1275",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1275",
    d: "M767.062,1844.094a5.232,5.232,0,0,0,.38-2.053l-.072-.041a5.374,5.374,0,0,1-.37,2.042Z",
    transform: "translate(-752.857 -1824.018)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1276",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1276",
    d: "M756.791,1792.417a13.013,13.013,0,0,0-1.129-2.617l-.062.041a12.918,12.918,0,0,1,1.109,2.576Z",
    transform: "translate(-742.627 -1777.176)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1277",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1277",
    d: "M740.276,1768.291a12.776,12.776,0,0,0-1.745-2.391l-.031.072a12.674,12.674,0,0,1,1.714,2.35Z",
    transform: "translate(-727.282 -1755.729)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1278",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1278",
    d: "M668.1,1807.1a13.466,13.466,0,0,0,1.18,2.679l.062-.041a13.269,13.269,0,0,1-1.17-2.627Z",
    transform: "translate(-664.107 -1792.7)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1279",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1279",
    d: "M664.01,1758.7a5.423,5.423,0,0,0-.411,2.114l.072.041a5.186,5.186,0,0,1,.39-2.094Z",
    transform: "translate(-660.069 -1749.268)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1280",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1280",
    d: "M718.7,1749.3v.092a9.351,9.351,0,0,1,1.971,1.622l.031-.072A9.626,9.626,0,0,0,718.7,1749.3Z",
    transform: "translate(-709.514 -1740.833)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1281",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1281",
    d: "M767.182,1818.617a9.415,9.415,0,0,0-.4-2.607l-.082-.01a9.548,9.548,0,0,1,.411,2.566Z",
    transform: "translate(-752.587 -1800.687)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1282",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1282",
    d: "M699.773,1742.531v-.092a.036.036,0,0,1-.021-.01,5.4,5.4,0,0,0-2.053-.729l.021.082a5.467,5.467,0,0,1,1.991.718A.089.089,0,0,1,699.773,1742.531Z",
    transform: "translate(-690.669 -1734.012)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1283",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1283",
    d: "M663.7,1780.2a9.355,9.355,0,0,0,.431,2.689l.082.01a9.385,9.385,0,0,1-.431-2.648Z",
    transform: "translate(-660.159 -1768.561)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1284",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1284",
    d: "M663.075,1736.772h0l-.031-.072h-.01a3.367,3.367,0,0,0-1.334,1.509l.062.062A3.193,3.193,0,0,1,663.075,1736.772Z",
    transform: "translate(-658.364 -1729.526)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1285",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1285",
    d: "M718.7,1880.592a5.8,5.8,0,0,0,2.32.76l-.021-.082a5.744,5.744,0,0,1-2.3-.77Z",
    transform: "translate(-709.514 -1858.567)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1286",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1286",
    d: "M675.2,1836.241a14.873,14.873,0,0,0,2.032,2.7l.031-.072a14.5,14.5,0,0,1-2-2.669Z",
    transform: "translate(-670.479 -1818.813)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1287",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1287",
    d: "M761.934,1869.161l-.062-.062a3.248,3.248,0,0,1-1.273,1.509l.041.062A3.347,3.347,0,0,0,761.934,1869.161Z",
    transform: "translate(-747.114 -1848.337)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1288",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1288",
    d: "M718.7,1741.5v.092a10.591,10.591,0,0,1,2.237,1.837l.031-.072A10.918,10.918,0,0,0,718.7,1741.5Z",
    transform: "translate(-709.514 -1733.833)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1289",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1289",
    d: "M773.344,1819.556a10.351,10.351,0,0,0-.462-2.946l-.082-.01a10.9,10.9,0,0,1,.462,2.9Z",
    transform: "translate(-758.061 -1801.225)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1290",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1290",
    d: "M657.452,1752.2a5.8,5.8,0,0,0-.452,2.381l.072.041a5.872,5.872,0,0,1,.441-2.361Z",
    transform: "translate(-654.147 -1743.435)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1291",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1291",
    d: "M773.362,1848.171a5.934,5.934,0,0,0,.431-2.33l-.072-.041a5.872,5.872,0,0,1-.421,2.309Z",
    transform: "translate(-758.51 -1827.428)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1292",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1292",
    d: "M677.45,1732.74l-.021-.082a3.366,3.366,0,0,0-1.93.359l.041.062a3.139,3.139,0,0,1,1.519-.37Z",
    transform: "translate(-670.748 -1725.884)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1293",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1293",
    d: "M697.44,1733.924v-.092a.036.036,0,0,1-.021-.01,6.142,6.142,0,0,0-2.32-.821l.021.082a5.971,5.971,0,0,1,2.258.811A.088.088,0,0,1,697.44,1733.924Z",
    transform: "translate(-688.336 -1726.205)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1294",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1294",
    d: "M761.734,1790.056a14.932,14.932,0,0,0-1.273-2.956l-.062.041a13.989,13.989,0,0,1,1.262,2.915Z",
    transform: "translate(-746.934 -1774.753)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1295",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1295",
    d: "M695.631,1862.7l-.031.072a10.459,10.459,0,0,0,2.227,1.765l.062.031v-.092a.036.036,0,0,1-.021-.01A9.9,9.9,0,0,1,695.631,1862.7Z",
    transform: "translate(-688.785 -1842.594)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1296",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1296",
    d: "M656.9,1776.3a10.634,10.634,0,0,0,.482,3.028l.082.01a10.363,10.363,0,0,1-.482-2.987Z",
    transform: "translate(-654.057 -1765.061)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1297",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1297",
    d: "M661.9,1806.5a14.55,14.55,0,0,0,1.334,3.018l.062-.041a14.443,14.443,0,0,1-1.314-2.976Z",
    transform: "translate(-658.544 -1792.162)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1298",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1298",
    d: "M741.9,1884.69l.021.082c.082,0,.164.01.236.01a3.275,3.275,0,0,0,1.632-.421h.01l-.041-.062h-.01A3.2,3.2,0,0,1,741.9,1884.69Z",
    transform: "translate(-730.333 -1861.977)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1299",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1299",
    d: "M743.012,1762.8a14.866,14.866,0,0,0-1.981-2.7l-.031.072a14.9,14.9,0,0,1,1.95,2.658Z",
    transform: "translate(-729.525 -1750.524)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1300",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1300",
    d: "M779.7,1820.495a11.688,11.688,0,0,0-.513-3.284l-.082-.01a11.483,11.483,0,0,1,.513,3.254Z",
    transform: "translate(-763.715 -1801.763)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1301",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1301",
    d: "M693.131,1868.5l-.031.072a11.647,11.647,0,0,0,2.484,1.971l.062.031v-.092a.036.036,0,0,1-.021-.01A10.858,10.858,0,0,1,693.131,1868.5Z",
    transform: "translate(-686.542 -1847.798)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1302",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1302",
    d: "M650.7,1745.6a6.532,6.532,0,0,0-.5,2.658l.072.041a6.61,6.61,0,0,1,.493-2.638Z",
    transform: "translate(-648.045 -1737.512)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1303",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1303",
    d: "M766.588,1787.595a16,16,0,0,0-1.427-3.295l-.062.041a15.6,15.6,0,0,1,1.406,3.254Z",
    transform: "translate(-751.152 -1772.24)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1304",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1304",
    d: "M656.929,1728.472h0l-.031-.072h-.01a3.6,3.6,0,0,0-1.488,1.694l.062.062A3.645,3.645,0,0,1,656.929,1728.472Z",
    transform: "translate(-652.711 -1722.078)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1305",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1305",
    d: "M718.7,1733.7v.092a12.165,12.165,0,0,1,2.494,2.042l.031-.072A12.1,12.1,0,0,0,718.7,1733.7Z",
    transform: "translate(-709.514 -1726.834)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1306",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1306",
    d: "M670.5,1838.941a16.168,16.168,0,0,0,2.268,3.007l.031-.072a15.75,15.75,0,0,1-2.227-2.976Z",
    transform: "translate(-666.261 -1821.236)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1307",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1307",
    d: "M672.966,1724.017l-.021-.082a3.738,3.738,0,0,0-2.145.4l.041.062a3.475,3.475,0,0,1,1.693-.411C672.668,1724,672.812,1724,672.966,1724.017Z",
    transform: "translate(-666.53 -1718.054)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1308",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1308",
    d: "M744.5,1893.031l.021.082a2.5,2.5,0,0,0,.277.01,3.585,3.585,0,0,0,1.806-.462h.01l-.041-.062h-.01A3.64,3.64,0,0,1,744.5,1893.031Z",
    transform: "translate(-732.666 -1869.425)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1309",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1309",
    d: "M718.7,1888.392a6.424,6.424,0,0,0,2.6.852l-.021-.082a6.488,6.488,0,0,1-2.566-.862Z",
    transform: "translate(-709.514 -1865.566)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1310",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1310",
    d: "M745.838,1757.407a16.561,16.561,0,0,0-2.207-3.007l-.031.072a16.1,16.1,0,0,1,2.176,2.966Z",
    transform: "translate(-731.858 -1745.409)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1311",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1311",
    d: "M695.107,1725.316v-.092a.036.036,0,0,1-.021-.01,6.555,6.555,0,0,0-2.586-.914l.021.082a6.722,6.722,0,0,1,2.525.9A.089.089,0,0,1,695.107,1725.316Z",
    transform: "translate(-686.003 -1718.398)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1312",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1312",
    d: "M655.6,1806a16.221,16.221,0,0,0,1.478,3.356l.062-.041a16.662,16.662,0,0,1-1.468-3.315Z",
    transform: "translate(-652.89 -1791.713)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1313",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1313",
    d: "M650.2,1772.4a11.915,11.915,0,0,0,.534,3.366l.082.01a12.107,12.107,0,0,1-.544-3.336Z",
    transform: "translate(-648.045 -1761.562)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1314",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1314",
    d: "M766.788,1875.661l-.062-.062a3.568,3.568,0,0,1-1.427,1.683l.041.062A3.605,3.605,0,0,0,766.788,1875.661Z",
    transform: "translate(-751.331 -1854.169)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1315",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1315",
    d: "M779.562,1852.438a6.659,6.659,0,0,0,.482-2.6l-.072-.041a6.612,6.612,0,0,1-.472,2.586Z",
    transform: "translate(-764.074 -1831.017)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1316",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1316",
    d: "M785.951,1856.515a7.216,7.216,0,0,0,.534-2.874l-.072-.041a7.458,7.458,0,0,1-.513,2.853Z",
    transform: "translate(-769.817 -1834.427)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1317",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1317",
    d: "M692.684,1716.619v-.092a.036.036,0,0,1-.021-.01,7.481,7.481,0,0,0-2.864-1.016l.021.082a7.341,7.341,0,0,1,2.8,1A.214.214,0,0,1,692.684,1716.619Z",
    transform: "translate(-683.58 -1710.502)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1318",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1318",
    d: "M649.4,1805.4a17.865,17.865,0,0,0,1.632,3.695l.062-.041a17.461,17.461,0,0,1-1.611-3.654Z",
    transform: "translate(-647.327 -1791.175)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1319",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1319",
    d: "M771.632,1785.144a18,18,0,0,0-1.57-3.644l-.062.041a17.549,17.549,0,0,1,1.56,3.592Z",
    transform: "translate(-755.549 -1769.728)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1320",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1320",
    d: "M747.1,1901.282l.021.082c.1.01.216.01.318.01a3.967,3.967,0,0,0,1.991-.513h.01l-.041-.062h-.01A3.888,3.888,0,0,1,747.1,1901.282Z",
    transform: "translate(-734.999 -1876.783)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1321",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1321",
    d: "M644.054,1739.1a7.219,7.219,0,0,0-.554,2.925l.072.041a7.208,7.208,0,0,1,.544-2.915Z",
    transform: "translate(-642.032 -1731.679)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1322",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1322",
    d: "M643.4,1768.5a13.04,13.04,0,0,0,.6,3.715l.082.01a13.072,13.072,0,0,1-.6-3.674Z",
    transform: "translate(-641.943 -1758.062)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1323",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1323",
    d: "M690.631,1874.2l-.031.072a13,13,0,0,0,2.751,2.186l.062.031v-.092a.036.036,0,0,1-.021-.01A12.211,12.211,0,0,1,690.631,1874.2Z",
    transform: "translate(-684.298 -1852.913)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1324",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1324",
    d: "M748.663,1751.915a18.265,18.265,0,0,0-2.432-3.315l-.031.072a17.468,17.468,0,0,1,2.4,3.274Z",
    transform: "translate(-734.191 -1740.204)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1325",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1325",
    d: "M668.391,1715.294l-.021-.082a4.08,4.08,0,0,0-2.371.452l.041.072a3.859,3.859,0,0,1,1.878-.462A2.5,2.5,0,0,1,668.391,1715.294Z",
    transform: "translate(-662.223 -1710.224)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1326",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1326",
    d: "M771.832,1882.261l-.062-.062a4.1,4.1,0,0,1-1.57,1.868l.041.062A4.143,4.143,0,0,0,771.832,1882.261Z",
    transform: "translate(-755.728 -1860.092)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1327",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1327",
    d: "M785.947,1821.344a13.1,13.1,0,0,0-.564-3.633l-.082-.01a13.168,13.168,0,0,1,.575,3.592Z",
    transform: "translate(-769.278 -1802.212)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1328",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1328",
    d: "M718.7,1725.9v.092a13.133,13.133,0,0,1,2.761,2.258l.031-.072A13.078,13.078,0,0,0,718.7,1725.9Z",
    transform: "translate(-709.514 -1719.834)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1329",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1329",
    d: "M665.7,1841.831a17.86,17.86,0,0,0,2.494,3.315l.031-.072a18.225,18.225,0,0,1-2.463-3.274Z",
    transform: "translate(-661.954 -1823.839)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1330",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1330",
    d: "M650.883,1720.172h0l-.031-.072h-.01a4.077,4.077,0,0,0-1.642,1.868l.062.062A4,4,0,0,1,650.883,1720.172Z",
    transform: "translate(-647.147 -1714.63)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1331",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1331",
    d: "M718.7,1896.192a7.165,7.165,0,0,0,2.864.944l-.021-.082a7.235,7.235,0,0,1-2.833-.954v.092Z",
    transform: "translate(-709.514 -1872.565)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1332",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1332",
    d: "M721.717,1720.656l.031-.072a14.586,14.586,0,0,0-3.048-2.484v.092A14.317,14.317,0,0,1,721.717,1720.656Z",
    transform: "translate(-709.514 -1712.835)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1333",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1333",
    d: "M643.2,1804.8a19.542,19.542,0,0,0,1.776,4.044l.062-.041a19.409,19.409,0,0,1-1.765-3.993Z",
    transform: "translate(-641.763 -1790.636)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1334",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1334",
    d: "M691.048,1882.4a13.976,13.976,0,0,1-3.018-2.4l-.031.072a13.81,13.81,0,0,0,3.007,2.391l.062.031v-.093C691.069,1882.412,691.059,1882.412,691.048,1882.4Z",
    transform: "translate(-681.965 -1858.118)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1335",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1335",
    d: "M751.3,1746.423a20.01,20.01,0,0,0-2.669-3.623l-.031.072a18.723,18.723,0,0,1,2.628,3.582Z",
    transform: "translate(-736.345 -1734.999)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1336",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1336",
    d: "M663.807,1706.564l-.021-.082a4.373,4.373,0,0,0-2.586.493l.041.072a4.194,4.194,0,0,1,2.053-.5A2.9,2.9,0,0,1,663.807,1706.564Z",
    transform: "translate(-657.916 -1702.387)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1337",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1337",
    d: "M776.686,1888.762l-.062-.062a4.359,4.359,0,0,1-1.724,2.042l.041.062A4.4,4.4,0,0,0,776.686,1888.762Z",
    transform: "translate(-759.946 -1865.925)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1338",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1338",
    d: "M660.9,1844.531a19.555,19.555,0,0,0,2.72,3.623l.031-.072a19.926,19.926,0,0,1-2.689-3.582Z",
    transform: "translate(-657.646 -1826.261)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1339",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1339",
    d: "M776.486,1782.782a19.4,19.4,0,0,0-1.724-3.982l-.062.041a19.146,19.146,0,0,1,1.7,3.931Z",
    transform: "translate(-759.766 -1767.305)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1340",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1340",
    d: "M718.7,1904v.092a7.911,7.911,0,0,0,3.13,1.037l-.021-.082A8.026,8.026,0,0,1,718.7,1904Z",
    transform: "translate(-709.514 -1879.655)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1341",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1341",
    d: "M690.289,1707.97c.021.01.041.031.062.041v-.092a.036.036,0,0,1-.021-.01,8.231,8.231,0,0,0-3.13-1.109l.021.082A7.916,7.916,0,0,1,690.289,1707.97Z",
    transform: "translate(-681.247 -1702.694)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1342",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1342",
    d: "M637.306,1732.5a7.955,7.955,0,0,0-.606,3.2l.072.041a7.858,7.858,0,0,1,.6-3.182Z",
    transform: "translate(-635.93 -1725.757)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1343",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1343",
    d: "M749.8,1909.723l.021.082c.123.01.236.01.359.01a4.278,4.278,0,0,0,2.166-.554h.01l-.041-.062h-.01A4.436,4.436,0,0,1,749.8,1909.723Z",
    transform: "translate(-737.422 -1884.321)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1344",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1344",
    d: "M792.251,1860.692a8.1,8.1,0,0,0,.585-3.151l-.072-.041a8.043,8.043,0,0,1-.565,3.13Z",
    transform: "translate(-775.47 -1837.927)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1345",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1345",
    d: "M636.7,1764.6a14.321,14.321,0,0,0,.647,4.054l.082.01a13.992,13.992,0,0,1-.647-4.013Z",
    transform: "translate(-635.93 -1754.562)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1346",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1346",
    d: "M792.208,1822.282a14.034,14.034,0,0,0-.626-3.972l-.082-.01a14.185,14.185,0,0,1,.626,3.931Z",
    transform: "translate(-774.842 -1802.751)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1347",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1347",
    d: "M644.737,1711.972h0l-.031-.072h-.01a4.388,4.388,0,0,0-1.8,2.042l.062.062A4.277,4.277,0,0,1,644.737,1711.972Z",
    transform: "translate(-641.494 -1707.271)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1348",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1348",
    d: "M738.439,1725.495l-.339-.2q.662.57,1.293,1.232l.031-.072C739.1,1726.121,738.767,1725.792,738.439,1725.495Z",
    transform: "translate(-726.923 -1719.296)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1349",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1349",
    d: "M798.4,1864.8l.062.062a8.827,8.827,0,0,0,.636-3.418l-.072-.041A8.917,8.917,0,0,1,798.4,1864.8Z",
    transform: "translate(-781.034 -1841.427)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1350",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1350",
    d: "M781.43,1780.321a21.566,21.566,0,0,0-1.868-4.321l-.062.041a20.948,20.948,0,0,1,1.858,4.28Z",
    transform: "translate(-764.074 -1764.792)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1351",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1351",
    d: "M685.821,1698.428l-.267-.154a6.7,6.7,0,0,0-.955-.174l.021.082A6.591,6.591,0,0,1,685.821,1698.428Z",
    transform: "translate(-678.914 -1694.888)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1352",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1352",
    d: "M686.342,1886.593l.339.195c-.39-.339-.78-.7-1.15-1.088l-.031.072A10.537,10.537,0,0,0,686.342,1886.593Z",
    transform: "translate(-679.722 -1863.233)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1353",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1353",
    d: "M658.668,1697.842a5.351,5.351,0,0,1,.565.031l-.021-.082a4.856,4.856,0,0,0-2.812.534l.041.072A4.539,4.539,0,0,1,658.668,1697.842Z",
    transform: "translate(-653.608 -1694.589)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1354",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1354",
    d: "M754.063,1741.072l.062-.041a21.357,21.357,0,0,0-2.894-3.931l-.031.072A21.826,21.826,0,0,1,754.063,1741.072Z",
    transform: "translate(-738.678 -1729.885)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1355",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1355",
    d: "M781.64,1895.362l-.062-.062a4.727,4.727,0,0,1-1.878,2.217l.041.062A4.817,4.817,0,0,0,781.64,1895.362Z",
    transform: "translate(-764.253 -1871.848)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1356",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1356",
    d: "M755.13,1917.3a4.621,4.621,0,0,1-2.73.575l.021.082c.133.01.267.01.4.01a4.66,4.66,0,0,0,2.35-.605h.01l-.051-.062Z",
    transform: "translate(-739.755 -1891.59)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1357",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1357",
    d: "M637,1804.3a21.5,21.5,0,0,0,1.93,4.383l.062-.041a21.005,21.005,0,0,1-1.909-4.331Z",
    transform: "translate(-636.199 -1790.188)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1358",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1358",
    d: "M629.982,1760.741l-.082-.041a15.6,15.6,0,0,0,.7,4.393l.082.01A15.4,15.4,0,0,1,629.982,1760.741Z",
    transform: "translate(-629.828 -1751.062)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1359",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1359",
    d: "M656.262,1847.2l-.062.041a20.917,20.917,0,0,0,2.946,3.931l.031-.072A20.879,20.879,0,0,1,656.262,1847.2Z",
    transform: "translate(-653.429 -1828.684)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1360",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1360",
    d: "M738.6,1920.4l.257.154a7.242,7.242,0,0,0,1.1.185l-.021-.082A7.089,7.089,0,0,1,738.6,1920.4Z",
    transform: "translate(-727.372 -1894.371)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1361",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1361",
    d: "M638.591,1703.672h0l-.031-.072h-.01a4.813,4.813,0,0,0-1.95,2.217l.062.062A4.747,4.747,0,0,1,638.591,1703.672Z",
    transform: "translate(-635.84 -1699.823)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1362",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1362",
    d: "M630.619,1726.062l-.062-.062a8.5,8.5,0,0,0-.657,3.469l.072.041A8.757,8.757,0,0,1,630.619,1726.062Z",
    transform: "translate(-629.828 -1719.924)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1363",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1363",
    d: "M798.477,1823.08l.082.041a15.375,15.375,0,0,0-.677-4.311l-.082-.01A15.94,15.94,0,0,1,798.477,1823.08Z",
    transform: "translate(-780.495 -1803.199)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1364",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1364",
    d: "M761.007,1925.6a4.964,4.964,0,0,1-2.607.636l.133.082a4.921,4.921,0,0,0,2.5-.647h.01l-.041-.072Z",
    transform: "translate(-745.139 -1899.038)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1365",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1365",
    d: "M629.2,1795.6v.3c.041.154.082.308.133.462l.082.01C629.344,1796.1,629.272,1795.856,629.2,1795.6Z",
    transform: "translate(-629.2 -1782.38)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1366",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1366",
    d: "M632.445,1695.372h0l-.031-.072h-.01a5.175,5.175,0,0,0-2.1,2.391l.062.062A5.166,5.166,0,0,1,632.445,1695.372Z",
    transform: "translate(-630.187 -1692.375)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1367",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1367",
    d: "M654.053,1689.082h.113l-.133-.082a5,5,0,0,0-2.432.605l.041.072A4.886,4.886,0,0,1,654.053,1689.082Z",
    transform: "translate(-649.301 -1686.721)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1368",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1368",
    d: "M758.105,1736.913l-.205-.113a22.653,22.653,0,0,1,2.658,3.726l.062-.041A22.756,22.756,0,0,0,758.105,1736.913Z",
    transform: "translate(-744.691 -1729.615)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1369",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1369",
    d: "M804.349,1820.755v-.339c-.082-.339-.175-.677-.267-1.006l-.082-.01C804.133,1819.851,804.246,1820.3,804.349,1820.755Z",
    transform: "translate(-786.059 -1803.738)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1370",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1370",
    d: "M804.887,1893.557v-.257a6.716,6.716,0,0,1-.287.8l.062.062C804.744,1893.967,804.816,1893.772,804.887,1893.557Z",
    transform: "translate(-786.598 -1870.053)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1371",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1371",
    d: "M653.833,1853.369l.205.113a23.179,23.179,0,0,1-2.576-3.582l-.062.041A22.189,22.189,0,0,0,653.833,1853.369Z",
    transform: "translate(-649.122 -1831.107)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1372",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1372",
    d: "M629.2,1719.605v.216a3.746,3.746,0,0,1,.144-.359l-.062-.062A1.214,1.214,0,0,1,629.2,1719.605Z",
    transform: "translate(-629.2 -1714.001)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1373",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1373",
    d: "M630.882,1803.71l-.082-.01a22.853,22.853,0,0,0,2.073,4.721l.062-.041A22.372,22.372,0,0,1,630.882,1803.71Z",
    transform: "translate(-630.636 -1789.649)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1374",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1374",
    d: "M784.5,1904.2l.041.062a5.211,5.211,0,0,0,2.053-2.4l-.062-.062A5.123,5.123,0,0,1,784.5,1904.2Z",
    transform: "translate(-768.561 -1877.68)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1375",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1375",
    d: "M786.2,1777.949l.082.01a22.716,22.716,0,0,0-2.022-4.66l-.062.041A22.226,22.226,0,0,1,786.2,1777.949Z",
    transform: "translate(-768.291 -1762.369)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1376",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1376",
    d: "M648.453,1681.362l-.1-.062a5.18,5.18,0,0,0-1.55.554l.041.072A4.94,4.94,0,0,1,648.453,1681.362Z",
    transform: "translate(-644.994 -1679.812)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1377",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1377",
    d: "M790.889,1774.688v-.226a24.634,24.634,0,0,0-1.827-3.962l-.062.041A25.042,25.042,0,0,1,790.889,1774.688Z",
    transform: "translate(-772.599 -1759.857)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1378",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1378",
    d: "M648.15,1855.092l.164.092a25.429,25.429,0,0,1-1.652-2.484l-.062.041A25.779,25.779,0,0,0,648.15,1855.092Z",
    transform: "translate(-644.814 -1833.62)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1379",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1379",
    d: "M771.864,1744.792l-.164-.092a25.258,25.258,0,0,1,1.735,2.627l.062-.041A23.684,23.684,0,0,0,771.864,1744.792Z",
    transform: "translate(-757.074 -1736.705)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1380",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1380",
    d: "M791.158,1914.754v-.154a5.247,5.247,0,0,1-1.858,1.93l.041.062A5.194,5.194,0,0,0,791.158,1914.754Z",
    transform: "translate(-772.868 -1889.167)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1381",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1381",
    d: "M630.934,1687.1a5.26,5.26,0,0,0-1.734,1.632v.144a5.091,5.091,0,0,1,1.765-1.7h.01l-.041-.072Z",
    transform: "translate(-629.2 -1685.017)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1382",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1382",
    d: "M629.2,1814.7v.216a23.821,23.821,0,0,0,1.745,3.654l.062-.041A24.564,24.564,0,0,1,629.2,1814.7Z",
    transform: "translate(-629.2 -1799.52)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1383",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1383",
    d: "M773.883,1933.86a5.173,5.173,0,0,1-1.683.606l.1.062a5.312,5.312,0,0,0,1.622-.6h.01l-.051-.072Z",
    transform: "translate(-757.523 -1906.446)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1384",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1384",
    d: "M795.465,1930.323v-.123a5.3,5.3,0,0,1-1.365,1.17l.041.062A5.015,5.015,0,0,0,795.465,1930.323Z",
    transform: "translate(-777.175 -1903.166)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1385",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1385",
    d: "M795.2,1770.563v-.2a28.136,28.136,0,0,0-1.334-2.668l-.062.041A31.315,31.315,0,0,1,795.2,1770.563Z",
    transform: "translate(-776.906 -1757.344)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1386",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1386",
    d: "M784.685,1942.1a5.27,5.27,0,0,1-.985.441l.092.051a5.9,5.9,0,0,0,.934-.421h.01l-.051-.072Z",
    transform: "translate(-767.843 -1913.844)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1387",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1387",
    d: "M642.954,1674.751l-.092-.051a6.455,6.455,0,0,0-.862.38l.041.072A5.135,5.135,0,0,1,642.954,1674.751Z",
    transform: "translate(-640.686 -1673.889)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1388",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1388",
    d: "M642.662,1856.927l.144.082c-.328-.493-.647-1-.944-1.509l-.062.041Q642.216,1856.249,642.662,1856.927Z",
    transform: "translate(-640.507 -1836.133)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1389",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1389",
    d: "M630.442,1678.8a5.469,5.469,0,0,0-1.242.985v.113a5.421,5.421,0,0,1,1.283-1.037h.01l-.051-.062Z",
    transform: "translate(-629.2 -1677.568)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1390",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1390",
    d: "M783.544,1751.482l-.144-.082c.359.534.708,1.088,1.026,1.652l.062-.041C784.19,1752.5,783.872,1751.985,783.544,1751.482Z",
    transform: "translate(-767.573 -1742.717)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1391",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1391",
    d: "M629.2,1829.6v.185a26.125,26.125,0,0,0,1.252,2.443l.062-.041A26.6,26.6,0,0,1,629.2,1829.6Z",
    transform: "translate(-629.2 -1812.891)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1392",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1392",
    d: "M629.949,1670.5a6.416,6.416,0,0,0-.749.513v.1a6.082,6.082,0,0,1,.79-.554H630l-.051-.062Z",
    transform: "translate(-629.2 -1670.12)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1393",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1393",
    d: "M629.2,1842.6v.164c.236.472.493.944.76,1.406l.062-.041C629.744,1843.636,629.467,1843.123,629.2,1842.6Z",
    transform: "translate(-629.2 -1824.556)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1394",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1394",
    d: "M793.933,1757.482l-.133-.082c.154.246.3.493.441.749l.062-.041C794.19,1757.9,794.067,1757.7,793.933,1757.482Z",
    transform: "translate(-776.906 -1748.101)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1395",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1395",
    d: "M637.569,1668.651l-.082-.051c-.092.051-.2.092-.287.154l.041.062A3.256,3.256,0,0,0,637.569,1668.651Z",
    transform: "translate(-636.379 -1668.415)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1396",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1396",
    d: "M637.387,1858.823l.133.082c-.123-.205-.246-.4-.359-.605l-.062.041C637.192,1858.5,637.285,1858.659,637.387,1858.823Z",
    transform: "translate(-636.289 -1838.645)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1397",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1397",
    d: "M794.6,1950.4l-.4.216.082.051a4,4,0,0,0,.359-.2h.01l-.051-.072Z",
    transform: "translate(-777.265 -1921.292)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1398",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1398",
    d: "M799.683,1943.8v-.1a5,5,0,0,1-.883.646l.041.062A6.02,6.02,0,0,0,799.683,1943.8Z",
    transform: "translate(-781.393 -1915.28)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1399",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1399",
    d: "M799.5,1766.765v-.174c-.267-.534-.544-1.067-.842-1.591l-.062.041C798.918,1765.605,799.216,1766.18,799.5,1766.765Z",
    transform: "translate(-781.213 -1754.921)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1400",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1400",
    d: "M717.982,1820.993v-8.539l-.051-.154-.031.072v9.8l.082.041v-1.221Z",
    transform: "translate(-708.796 -1797.366)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1401",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1401",
    d: "M717.9,1714.821v8.539l.051.154.031-.072v-9.792l-.082-.051v1.221Z",
    transform: "translate(-708.796 -1708.797)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1402",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1402",
    d: "M727.419,1816.36l-.082-.051-.616-.349-.072-.051-.616-.349-.082-.051-.616-.349-.072-.051-.616-.349-.082-.051-.616-.349-.082-.051-.606-.349-.082-.051-.616-.349-.082-.051-.606-.349-.082-.051-.616-.349-.082-.051-.616-.349-.072-.051-1.037-.6-.072-.01.113.123,1,.575.072.041.616.359.082.041.616.359.072.041.626.359.072.041.616.359.072.041.626.359.072.041.616.359.072.041.626.359.072.041.616.359.082.041.616.359.072.041.616.359.082.041.616.359.072.041.236.133v-.082l-.236-.133-.072-.051Z",
    transform: "translate(-710.052 -1796.828)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1403",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1403",
    d: "M629.97,1759.934l.072.041.616.359.082.041.616.359.072.041.616.359.082.041.616.359.072.041.616.359.082.041.616.359.072.041.616.359.082.041.616.359.072.041.616.359.082.041.616.349.082.051,1.191.688.072.01-.113-.123-1.16-.667-.072-.041-.616-.359-.082-.041-.616-.359-.072-.041-.616-.359-.082-.041-.616-.359-.072-.041-.616-.359-.082-.041-.616-.359-.072-.041-.616-.359-.082-.041-.616-.359-.072-.041-.616-.359-.082-.041-.616-.359-.072-.041-.616-.359-.082-.041-.072-.041v.092l.072.041.082.041Z",
    transform: "translate(-629.2 -1749.896)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1404",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1404",
    d: "M726.962,1827.662l-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.072-.452-.78-.041-.072-.719-1.242-.113-.113.051.164.718,1.242.041.062.452.78.041.072.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.267.472h.092Z",
    transform: "translate(-709.513 -1798.534)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1405",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1405",
    d: "M636.676,1670.577l.041.072.452.78.041.062.452.78.041.072.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.062.452.78.041.072.452.78.041.072.452.78.041.062.8,1.386.113.113-.051-.164-.79-1.375-.041-.062-.452-.78-.041-.072-.452-.78-.041-.072-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.062-.452-.78-.041-.072-.452-.78-.041-.072-.452-.78-.041-.072-.452-.78-.041-.072-.452-.78-.041-.072-.452-.78-.041-.072-.452-.78-.041-.062-.185-.328H634.5l.216.369.041.062.452.78.041.062.452.78.041.062.452.78.041.072Z",
    transform: "translate(-633.956 -1666.8)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1406",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1406",
    d: "M725.276,1764.191l-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.76.441-.031.062.072.01.759-.441.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.277-.164c-.021-.021-.031-.041-.051-.062l-.267.154-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041Z",
    transform: "translate(-710.322 -1752.767)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1407",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1407",
    d: "M637.748,1814.469l.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.842-.482.031-.062-.072-.01-.842.482-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.421.246-.062.041-.2.113c.021.021.031.041.051.062l.185-.1.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041.421-.246.062-.041Z",
    transform: "translate(-634.495 -1796.199)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1408",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1408",
    d: "M682.721,1694.5l.021.082.246.811.031.082.236.811.031.082.246.811.021.082.246.811.021.082.246.811.031.082.236.811.031.082.246.811.021.082.246.811.021.082.246.811.021.082.246.821.031.072.421,1.416.051.164.072.072.021-.041-.051-.154-.431-1.437-.021-.082-.246-.811-.031-.092-.246-.811-.021-.082-.246-.811-.021-.082-.246-.811-.021-.082-.246-.811-.031-.082-.246-.811-.021-.082-.246-.811-.021-.082-.246-.811-.021-.082-.246-.811-.031-.082-.246-.811-.021-.082-.246-.811-.021-.082-.144-.462-.092-.051.154.5.021.082Z",
    transform: "translate(-676.85 -1690.401)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1409",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1409",
    d: "M721.464,1822.482l-.021-.072-.246-.821-.031-.082-.246-.811-.021-.082-.246-.811-.021-.082-.246-.811-.031-.082-.236-.811-.031-.082-.246-.811-.021-.082-.246-.811-.021-.082-.246-.821-.021-.072-.246-.821-.031-.072-.246-.821-.021-.072-.4-1.334-.051-.154-.072-.082-.021.041.051.154.411,1.365.021.082.246.811.031.082.246.811.021.082.246.821.021.072.246.821.021.072.246.821.031.072.246.821.021.072.246.821.021.072.246.821.021.082.246.811.031.082.246.811.021.082.246.811.021.082.164.534.092.062-.175-.6-.021-.072Z",
    transform: "translate(-709.065 -1797.008)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1410",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1410",
    d: "M726.96,1811.639h-.082l-.554-.051-.082-.01-.554-.051-.082-.01-.565-.051h-.082l-.554-.051-.082-.01-.554-.051-.082-.01-.554-.041-.082-.01-.565-.051-.082-.01-.554-.051h-.082l-.554-.051-.082-.01-.554-.051-.082-.01-.554-.051h-.082l-.985-.092-.062-.01-.01.031.051.051.072.01.955.082.082.01.554.051.082.01.554.051h.082l.554.051.082.01.565.052.082.01.554.051h.082l.554.051.082.01.554.051.082.01.565.041.082.01.554.051.082.01.554.051h.082l.554.051.082.01.565.051.082.01.267.021v-.072l-.3-.031-.082-.01Z",
    transform: "translate(-709.604 -1796.11)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1411",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1411",
    d: "M630,1802.954h.082l.554.051.082.01.554.051.082.01.554.051H632l.554.051.082.01.554.051.082.01.554.051h.082l.554.051.082.01.564.051.082.01.554.041.082.01.554.051.082.01.554.051h.082l1.119.1.072.01.01-.031-.062-.051-.072-.01-1.088-.092-.082-.01-.554-.052-.082-.01-.564-.051h-.082l-.554-.051-.082-.01-.554-.051-.082-.01-.554-.041-.082-.01-.564-.051-.082-.01-.554-.051h-.082l-.554-.051-.082-.01-.554-.051-.082-.01-.554-.051h-.082l-.565-.051-.082-.01-.554-.051-.082-.01-.133-.01v.082l.164.01.082.01Z",
    transform: "translate(-629.2 -1788.842)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1412",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1412",
    d: "M630.575,1718.95l.062.062.585.616.051.062.585.606.062.062.585.616.051.062.585.606.062.062.585.616.062.062.585.616.051.051.585.616.062.062.585.616.051.052.585.616.062.062.585.616.051.062,1.078,1.119.113.123.062.051.031-.072-.072-.072-.113-.113-1.057-1.119-.062-.051-.585-.616-.051-.062-.585-.616-.062-.062-.585-.605-.062-.062-.585-.616-.051-.062-.585-.616-.062-.051-.585-.616-.051-.062-.585-.616-.062-.051-.585-.616-.051-.062-.6-.616-.051-.062-.585-.606-.062-.062-.585-.616-.051-.062-.585-.606-.062-.062-.123-.133v.113l.092.092.051.062.585.616.062.062Z",
    transform: "translate(-629.2 -1712.207)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1413",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1413",
    d: "M726.026,1819.144l-.062-.062-.585-.616-.062-.062-.585-.606-.051-.062-.585-.616-.062-.062-.585-.606-.062-.062-.575-.616-.062-.062-.585-.606-.062-.062-.585-.616-.051-.062-.585-.616-.062-.051-.585-.616-.062-.062-.575-.616-.062-.062-.934-.975-.113-.123-.051-.051-.041.072.072.082.113.113.924.965.051.062.585.616.062.051.585.616.062.062.585.616.051.062.585.605.062.062.585.616.051.062.585.605.062.062.585.616.062.062.585.606.051.062.585.616.062.062.585.606.051.062.585.616.062.062.585.606.051.062.267.277v-.113l-.226-.236-.062-.062-.585-.616-.051-.062Z",
    transform: "translate(-709.245 -1796.379)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1414",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1414",
    d: "M684.4,1748.023l.041-.082.226-.513.031-.072.226-.513.031-.082.236-.513.031-.072.226-.513.031-.082.236-.513.031-.072.226-.513.031-.082.236-.513.031-.072.226-.523.031-.072.236-.513.031-.072.421-.975.031-.072.021-.041.041-.072.01-.031.021-.051.421-.944.031-.072.226-.524.041-.072.226-.513.031-.082.226-.513.041-.072.226-.513.031-.082.226-.513.031-.072.236-.523.031-.072.226-.513.031-.072.236-.523.031-.072.226-.513.031-.082.226-.513.041-.072.226-.513.031-.082.154-.328-.072-.041-.133.308-.041.082-.226.513-.031.072-.226.523-.041.072-.226.513-.031.072-.226.524-.031.072-.236.513-.031.072-.226.523-.031.072-.236.513-.031.082-.226.513-.031.072-.226.513-.041.082-.226.513-.031.072-.226.513-.041.082-.4.913-.031.072-.021.041-.031.072-.01.031-.031.062-.441,1-.031.072-.226.513-.041.082-.226.513-.031.072-.226.513-.041.082-.226.513-.031.072-.226.523-.031.072-.236.513-.031.072-.226.523-.031.072-.236.513-.031.072-.226.523-.031.072-.226.513-.041.072-.226.523-.031.072-.123.287.062.031.113-.257.041-.072.226-.523.031-.072Z",
    transform: "translate(-678.106 -1726.654)",
    fill: "#eaeaea"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1415",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1415",
    d: "M829.724,1800.891c0,.636-.452.893-1.006.575l-7.113-4.105a2.217,2.217,0,0,1-1.006-1.734v-17.684c0-.636.452-.9,1.006-.575l7.113,4.105a2.217,2.217,0,0,1,1.006,1.735Z",
    transform: "translate(-799.108 -1762.822)",
    fill: "none",
    stroke: "#d1d1d1",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.997
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1416",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1416",
    d: "M934.117,1769.939v21.574a.825.825,0,0,1-.216.616h0a.609.609,0,0,1-.205.123l-8.262,4.824a.8.8,0,0,0,.246-.647v-21.574a2.193,2.193,0,0,0-.38-1.16h0l8.447-4.9h0A2.2,2.2,0,0,1,934.117,1769.939Z",
    transform: "translate(-893.062 -1750.335)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1417",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1417",
    d: "M1007.5,1768.7Z",
    transform: "translate(-966.825 -1750.246)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1418",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1418",
    d: "M617.475,1641.052c0,.185-.133.256-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.657.657,0,0,1,617.475,1641.052Z",
    transform: "translate(-616.315 -1635.211)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1419",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1419",
    d: "M718.175,1698.552c0,.185-.133.257-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.656.656,0,0,1,718.175,1698.552Z",
    transform: "translate(-706.68 -1686.81)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1420",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1420",
    d: "M818.475,1757.651c0,.185-.133.257-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.629.629,0,0,1,818.475,1757.651Z",
    transform: "translate(-796.685 -1739.844)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1421",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1421",
    d: "M918.975,1817.052c0,.185-.133.257-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.629.629,0,0,1,918.975,1817.052Z",
    transform: "translate(-886.87 -1793.147)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1422",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1422",
    d: "M617.475,1857.751c0,.185-.133.257-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.657.657,0,0,1,617.475,1857.751Z",
    transform: "translate(-616.315 -1829.67)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1423",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1423",
    d: "M718.175,1915.251c0,.185-.133.257-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.657.657,0,0,1,718.175,1915.251Z",
    transform: "translate(-706.68 -1881.268)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1424",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1424",
    d: "M818.475,1974.452c0,.185-.133.257-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.629.629,0,0,1,818.475,1974.452Z",
    transform: "translate(-796.685 -1934.392)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1425",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1425",
    d: "M918.975,2033.751c0,.185-.133.257-.287.164a.629.629,0,0,1-.287-.5c0-.185.133-.257.287-.164A.629.629,0,0,1,918.975,2033.751Z",
    transform: "translate(-886.87 -1987.606)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_97",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 97",
    transform: "translate(35.995 35.828)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1426",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1426",
    d: "M962.906,1953a.382.382,0,0,0,.123.318l-.955-.565-.01-.01a.364.364,0,0,1-.164-.349v-3.818a1.148,1.148,0,0,1,.185-.575l.985.626a1.112,1.112,0,0,0-.164.544Z",
    transform: "translate(-961.9 -1946.971)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1427",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1427",
    d: "M966.5,1938.611a.369.369,0,0,0-.38.031l-.482.277-.585.339a1.094,1.094,0,0,0-.37.38l-.985-.626a1.133,1.133,0,0,1,.349-.349l1.057-.616a.4.4,0,0,1,.359-.051l.041.031Z",
    transform: "translate(-963.515 -1937.971)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1428",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1428",
    d: "M973.825,1944.163v3.818a1.18,1.18,0,0,1-.534.924l-1.057.616a.361.361,0,0,1-.328.051h-.01l-.072-.041a.415.415,0,0,1-.123-.318V1945.4a1.112,1.112,0,0,1,.164-.544,1.012,1.012,0,0,1,.369-.38l.585-.339.482-.277a.348.348,0,0,1,.38-.031A.38.38,0,0,1,973.825,1944.163Z",
    transform: "translate(-970.694 -1943.186)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1429",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1429",
    d: "M975.117,1945.526v3.818a1.022,1.022,0,0,1-.452.79l-1.057.616a.377.377,0,0,1-.164.051.062.062,0,0,1-.041-.01l-.041-.021a.226.226,0,0,1-.031-.051.329.329,0,0,1-.031-.144v-3.818a.929.929,0,0,1,.144-.462.956.956,0,0,1,.308-.328l1.057-.616a.376.376,0,0,1,.164-.051h0c.031,0,.051,0,.062.02A.228.228,0,0,1,975.117,1945.526Z",
    transform: "translate(-972.13 -1944.548)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1430",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1430",
    d: "M974.993,1945.444v3.818a1.022,1.022,0,0,1-.452.79l-1.057.616a.385.385,0,0,1-.154.051.328.328,0,0,1-.031-.144v-3.818a.93.93,0,0,1,.144-.462.954.954,0,0,1,.308-.328l1.057-.616a.376.376,0,0,1,.164-.051A.606.606,0,0,1,974.993,1945.444Z",
    transform: "translate(-972.13 -1944.548)",
    fill: "#b7b7b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_98",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 98",
    transform: "translate(36.036 23.222)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1431",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1431",
    d: "M964.445,1815.585v2.515a1.355,1.355,0,0,1-.626,1.078l-.893.523a.463.463,0,0,1-.39.062h-.01l-.082-.051a.492.492,0,0,1-.144-.37v-2.515a1.273,1.273,0,0,1,.2-.636,1.186,1.186,0,0,1,.431-.441l.339-.2.554-.318a.379.379,0,0,1,.626.349Z",
    transform: "translate(-962.3 -1815.149)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1432",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1432",
    d: "M965.786,1817.067v2.515a1.192,1.192,0,0,1-.534.924l-.893.523a.39.39,0,0,1-.185.062.093.093,0,0,1-.051-.01l-.051-.031a.131.131,0,0,1-.041-.062.392.392,0,0,1-.031-.164v-2.515a1.145,1.145,0,0,1,.164-.544,1.07,1.07,0,0,1,.359-.38l.749-.441.144-.082a.389.389,0,0,1,.185-.062h0a.11.11,0,0,1,.082.021A.257.257,0,0,1,965.786,1817.067Z",
    transform: "translate(-963.826 -1816.63)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1433",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1433",
    d: "M965.383,1818.2v2.3a1.208,1.208,0,0,1-.534.924l-.749.441v-2.3a1.144,1.144,0,0,1,.164-.544,1.069,1.069,0,0,1,.359-.38Z",
    transform: "translate(-963.915 -1817.887)",
    fill: "#6d6d6d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_99",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 99",
    transform: "translate(36.159 30.104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1434",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1434",
    d: "M965.009,1893.751l-1.509-.872V1889.8l.749.441.76,1.457Z",
    transform: "translate(-963.5 -1889.02)",
    fill: "#ddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1435",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1435",
    d: "M970.8,1887.28l1.334-.78.76,1.488-1.334.749Z",
    transform: "translate(-970.051 -1886.059)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1436",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1436",
    d: "M978.2,1903.8l1.334-.78V1901l-1.334.749Z",
    transform: "translate(-976.691 -1899.07)",
    fill: "#c1c1c1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1437",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1437",
    d: "M963.5,1882.98l1.334-.78.749.441-1.334.78Z",
    transform: "translate(-963.5 -1882.2)",
    fill: "#e2e2e2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_127",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 127",
    transform: "translate(669.754 365.401)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_101",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 101",
    transform: "translate(27.476 3.302)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1438",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1438",
    d: "M1460.4,1931.2c0-1.632,1.15-2.3,2.566-1.478a5.668,5.668,0,0,1,2.566,4.444c0,1.632-1.149,2.3-2.566,1.478A5.669,5.669,0,0,1,1460.4,1931.2Z",
    transform: "translate(-1459.271 -1929.374)",
    fill: "#ea4b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1439",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1439",
    d: "M1455.6,1931.26l1.355-.76,3.6,6.281-1.211.677Z",
    transform: "translate(-1454.964 -1930.384)",
    fill: "#ea4b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1440",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1440",
    d: "M1449.4,1937.3c0-1.632,1.15-2.3,2.566-1.478a5.668,5.668,0,0,1,2.566,4.444c0,1.632-1.149,2.3-2.566,1.478A5.653,5.653,0,0,1,1449.4,1937.3Z",
    transform: "translate(-1449.4 -1934.848)",
    fill: "#c63734"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1441",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1441",
    d: "M1461.2,1951.765c0-.862.605-1.211,1.355-.78a2.982,2.982,0,0,1,1.355,2.34c0,.862-.606,1.211-1.355.78A2.982,2.982,0,0,1,1461.2,1951.765Z",
    transform: "translate(-1459.989 -1948.601)",
    fill: "#9e8b66"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_11",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 11",
    x1: 9.535,
    y1: 5.501,
    transform: "translate(21.892 7.38)",
    fill: "none",
    stroke: "#dbb56b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 16.132
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_102",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 102",
    transform: "translate(29.467 11.224)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1442",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1442",
    d: "M1471.551,2009.742l-2.556-1.468h0a.481.481,0,0,1-.195-.441,1.523,1.523,0,0,1,.677-1.18.47.47,0,0,1,.482-.051h0l2.556,1.468Z",
    transform: "translate(-1468.8 -2006.556)",
    fill: "#ba913f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1443",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1443",
    d: "M1495.155,2021.482c0-.431-.308-.605-.677-.39a1.5,1.5,0,0,0-.677,1.18c0,.431.308.606.677.39A1.523,1.523,0,0,0,1495.155,2021.482Z",
    transform: "translate(-1491.234 -2019.518)",
    fill: "#b28739"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_103",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 103",
    transform: "translate(32.338 13.017)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1444",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1444",
    d: "M1507.039,2031.145a.73.73,0,0,1-.411-.113l-9.535-5.5a.836.836,0,0,1,.831-1.427l9.535,5.5a.827.827,0,0,1,.308,1.129A.851.851,0,0,1,1507.039,2031.145Z",
    transform: "translate(-1496.772 -2024.024)",
    fill: "#dbb56b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_104",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 104",
    transform: "translate(34.558 13.894)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1445",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1445",
    d: "M1541.093,2047.87l-22.416-12.953h0a.664.664,0,0,1-.277-.606,2.06,2.06,0,0,1,.934-1.611.648.648,0,0,1,.657-.062h0l22.416,12.953Z",
    transform: "translate(-1518.4 -2032.575)",
    fill: "#ea4b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1446",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1446",
    d: "M1738.668,2159.51c0-.6-.421-.831-.934-.533a2.059,2.059,0,0,0-.934,1.611c0,.6.421.831.934.533A2.06,2.06,0,0,0,1738.668,2159.51Z",
    transform: "translate(-1714.384 -2145.887)",
    fill: "#c63734"
  })), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_12",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 12",
    x1: 5.429,
    y1: 3.13,
    transform: "translate(20.004 12.706)",
    fill: "none",
    stroke: "#dbb56b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 16.132
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_105",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 105",
    transform: "translate(24.602 14.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1447",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1447",
    d: "M1424.151,2045.042l-2.556-1.468h0a.48.48,0,0,1-.195-.441,1.524,1.524,0,0,1,.677-1.18.47.47,0,0,1,.482-.051h0l2.556,1.468Z",
    transform: "translate(-1421.4 -2041.856)",
    fill: "#ba913f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1448",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1448",
    d: "M1447.655,2056.782c0-.431-.308-.605-.677-.39a1.5,1.5,0,0,0-.677,1.18c0,.431.308.605.677.39A1.512,1.512,0,0,0,1447.655,2056.782Z",
    transform: "translate(-1443.744 -2054.818)",
    fill: "#b28739"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_106",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 106",
    transform: "translate(27.473 16.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1449",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1449",
    d: "M1459.639,2066.445a.731.731,0,0,1-.411-.113l-9.535-5.5a.836.836,0,0,1,.831-1.427l9.535,5.5a.827.827,0,0,1,.308,1.129A.851.851,0,0,1,1459.639,2066.445Z",
    transform: "translate(-1449.372 -2059.324)",
    fill: "#dbb56b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_107",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 107",
    transform: "translate(29.683 17.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1450",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1450",
    d: "M1492.916,2082.67l-21.738-12.552h0a.664.664,0,0,1-.277-.606,2.06,2.06,0,0,1,.934-1.611.649.649,0,0,1,.657-.062h0l21.738,12.552Z",
    transform: "translate(-1470.9 -2067.775)",
    fill: "#ba913f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1451",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1451",
    d: "M1684.568,2190.81c0-.6-.421-.831-.934-.534a2.061,2.061,0,0,0-.934,1.611c0,.6.421.832.934.534A2.06,2.06,0,0,0,1684.568,2190.81Z",
    transform: "translate(-1660.962 -2177.587)",
    fill: "#af8437"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_114",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 114",
    transform: "translate(11.475 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1452",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1452",
    d: "M1300.8,1931v2.474h0a2.828,2.828,0,0,0,1.663,2.32,8.851,8.851,0,0,0,8.026,0,2.815,2.815,0,0,0,1.663-2.32h0V1931Z",
    transform: "translate(-1300.051 -1927.531)",
    fill: "#c63734"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_113",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 113"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1453",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1453",
    d: "M1295.994,1898.093a2.01,2.01,0,0,0-.257.133.587.587,0,0,0-.39.021c-.082.041-.082.123-.031.226a3.942,3.942,0,0,0-.452.328.582.582,0,0,0-.369.062c-.062.052-.031.134.051.216a2.39,2.39,0,0,0-.267.308.519.519,0,0,0-.339.1c-.041.062.01.133.123.216a2.1,2.1,0,0,0-.185.41c-.174.031-.277.082-.3.144s.062.133.205.2c-.01.062-.021.133-.031.195-.164.052-.257.1-.257.175s.092.123.257.175a1.821,1.821,0,0,0,.082.41c-.144.072-.205.134-.185.2s.144.1.318.133a2.675,2.675,0,0,0,.185.328c-.113.082-.164.154-.113.216s.174.092.359.092a2.963,2.963,0,0,0,.359.359c-.082.092-.1.174-.031.226a.653.653,0,0,0,.39.051c.072.051.144.092.216.144-.062.1-.051.185.031.226a.632.632,0,0,0,.4.01c.174.092.37.175.554.257a.189.189,0,0,0,.113.226.667.667,0,0,0,.39-.031l.523.154a.241.241,0,0,0,.185.205.624.624,0,0,0,.38-.082c.226.041.452.082.688.1a.337.337,0,0,0,.257.185.513.513,0,0,0,.339-.123c.1.01.216.01.318.01a.407.407,0,0,0,.3.154.447.447,0,0,0,.308-.154c.236-.01.472-.021.7-.041a.514.514,0,0,0,.359.113.274.274,0,0,0,.236-.2c.185-.031.369-.062.544-.1a.572.572,0,0,0,.39.072.222.222,0,0,0,.164-.216,5.932,5.932,0,0,0,.605-.205.61.61,0,0,0,.4.021.166.166,0,0,0,.082-.226c.082-.041.164-.082.236-.123a.746.746,0,0,0,.411-.01c.082-.051.082-.133.021-.236a3.766,3.766,0,0,0,.441-.318.636.636,0,0,0,.39-.062c.062-.051.031-.133-.062-.236a2.319,2.319,0,0,0,.257-.3c.185-.01.318-.041.359-.1s-.01-.144-.144-.216a3.37,3.37,0,0,0,.185-.39c.185-.031.3-.082.318-.154s-.072-.133-.226-.2a1.13,1.13,0,0,0,.021-.185c.164-.051.267-.113.267-.174s-.1-.123-.267-.175a3.14,3.14,0,0,0-.072-.41c.144-.072.226-.144.195-.205s-.144-.113-.328-.134a1.966,1.966,0,0,0-.185-.318c.123-.082.164-.164.123-.216s-.175-.092-.359-.092a2.971,2.971,0,0,0-.359-.359c.082-.092.1-.174.031-.226a.651.651,0,0,0-.39-.052c-.072-.051-.144-.092-.216-.144.062-.1.051-.185-.021-.226a.632.632,0,0,0-.4-.01,5.391,5.391,0,0,0-.554-.257.173.173,0,0,0-.113-.216.667.667,0,0,0-.39.031,5.077,5.077,0,0,0-.523-.154.253.253,0,0,0-.185-.205.642.642,0,0,0-.37.072c-.226-.041-.462-.082-.7-.113a.324.324,0,0,0-.257-.175.429.429,0,0,0-.328.123c-.113-.01-.226-.01-.339-.01a.38.38,0,0,0-.6,0c-.246.01-.482.021-.718.041a.453.453,0,0,0-.339-.1.316.316,0,0,0-.236.175c-.195.031-.38.062-.575.1a.564.564,0,0,0-.37-.062.21.21,0,0,0-.164.205c-.216.062-.431.133-.636.205a.708.708,0,0,0-.38-.021C1295.994,1897.908,1295.963,1897.99,1295.994,1898.093Z",
    transform: "translate(-1293.5 -1897.2)",
    fill: "#ea4b3f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_19",
    "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 19",
    cx: 5.378,
    cy: 3.11,
    rx: 5.378,
    ry: 3.11,
    transform: "translate(0.913 0.493)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_108",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 108",
    transform: "translate(1.824 1.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1454",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1454",
    d: "M1312.591,1907.914a5.744,5.744,0,0,1,1.457-.565,8.393,8.393,0,0,1,1.252-.185,6.157,6.157,0,0,1,.872,0,6.26,6.26,0,0,1,1.252.185,5.076,5.076,0,0,1,1.457.565,2.971,2.971,0,0,1,.975.842,1.8,1.8,0,0,1,.308.729,1.382,1.382,0,0,1,0,.5,1.8,1.8,0,0,1-.308.729,2.97,2.97,0,0,1-.975.842,5.75,5.75,0,0,1-1.457.565,8.39,8.39,0,0,1-1.252.185,6.157,6.157,0,0,1-.872,0,6.466,6.466,0,0,1-1.262-.185,5.07,5.07,0,0,1-1.457-.565,2.97,2.97,0,0,1-.975-.842,1.8,1.8,0,0,1-.308-.729,1.377,1.377,0,0,1,0-.5,1.8,1.8,0,0,1,.308-.729A3.126,3.126,0,0,1,1312.591,1907.914Z",
    transform: "translate(-1311.275 -1907.15)",
    fill: "#2799c1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1455",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1455",
    d: "M1311.4,1929.8h8.878a1.382,1.382,0,0,1,0,.5H1311.4A1.382,1.382,0,0,1,1311.4,1929.8Z",
    transform: "translate(-1309.54 -1926.454)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1456",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1456",
    d: "M1350.5,1907.166a6.192,6.192,0,0,1,.872,0v5.122a6.192,6.192,0,0,1-.872,0v-5.122Z",
    transform: "translate(-1344.65 -1906.129)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1457",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1457",
    d: "M1315.575,1909.665a5.744,5.744,0,0,1,1.458-.565l5.819,3.366a2.969,2.969,0,0,1-.975.842,5.744,5.744,0,0,1-1.458.564l-5.819-3.366A2.97,2.97,0,0,1,1315.575,1909.665Z",
    transform: "translate(-1312.434 -1907.879)",
    fill: "#fa2209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1458",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1458",
    d: "M1314.6,1912.366l5.819-3.366a5.068,5.068,0,0,1,1.458.564,2.97,2.97,0,0,1,.975.842l-5.819,3.367a5.072,5.072,0,0,1-1.458-.565A2.97,2.97,0,0,1,1314.6,1912.366Z",
    transform: "translate(-1312.434 -1907.789)",
    fill: "#fa2209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1459",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1459",
    d: "M1317.772,1910.912a6.132,6.132,0,0,1,5.542,0c1.529.883,1.529,2.32,0,3.2a6.131,6.131,0,0,1-5.542,0C1316.243,1913.231,1316.243,1911.795,1317.772,1910.912Z",
    transform: "translate(-1314.251 -1908.911)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1460",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1460",
    d: "M1352.684,1931.063a.37.37,0,0,1,.329,0c.01.01.031.021.041.031a.092.092,0,0,1-.01.144c-.01.01-.021.01-.031.021a.369.369,0,0,1-.329,0c-.01-.01-.021-.01-.021-.021a.1.1,0,0,1,0-.154Z",
    transform: "translate(-1346.557 -1927.553)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_112",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 112",
    transform: "translate(5.885 3.11)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_109",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 109",
    transform: "translate(0 0.251)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1461",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1461",
    d: "M1351.375,1929.965a.631.631,0,0,0-.277,0,.347.347,0,0,0-.154.062c-.154.093-.144.246.021.339a.438.438,0,0,0,.164.051.832.832,0,0,0,.226,0,.49.49,0,0,0,.185-.062c.154-.092.144-.246-.021-.339A.593.593,0,0,0,1351.375,1929.965Zm.041.318a.078.078,0,0,1-.051.021.312.312,0,0,1-.236,0c-.01,0-.021-.01-.031-.01-.092-.051-.1-.133-.01-.185.01-.01.02-.01.031-.021a.343.343,0,0,1,.267,0c.01,0,.021.01.031.01C1351.488,1930.14,1351.5,1930.222,1351.416,1930.283Z",
    transform: "translate(-1350.835 -1929.95)",
    fill: "#2799c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_110",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 110",
    transform: "translate(0.294 0.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1462",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1462",
    d: "M1353.936,1933.4v.113l-.062,1.94-.164-1.94-.01-.113A.461.461,0,0,0,1353.936,1933.4Z",
    transform: "translate(-1353.7 -1933.4)",
    fill: "#2799c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_111",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 111",
    transform: "translate(0.243)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1463",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1463",
    d: "M1353.508,1927.5l-.01.267v.113a.4.4,0,0,0-.267,0l-.01-.113-.021-.246Z",
    transform: "translate(-1353.2 -1927.5)",
    fill: "#2799c1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_121",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 121",
    transform: "translate(0 6.641)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1464",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1464",
    d: "M1187.5,1991.7v2.474h0a2.829,2.829,0,0,0,1.663,2.32,8.85,8.85,0,0,0,8.026,0,2.816,2.816,0,0,0,1.663-2.32h0V1991.7Z",
    transform: "translate(-1186.905 -1988.641)",
    fill: "#0b7e99"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_120",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_115",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1465",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1465",
    d: "M1184.194,1962.792a2.027,2.027,0,0,0-.257.134.587.587,0,0,0-.39.021c-.082.041-.082.123-.031.226a3.953,3.953,0,0,0-.452.328.582.582,0,0,0-.369.062c-.062.051-.031.134.051.216a2.389,2.389,0,0,0-.267.308.519.519,0,0,0-.339.1c-.041.062.01.133.123.215a2.107,2.107,0,0,0-.185.411c-.174.031-.277.082-.3.144s.062.133.205.2c-.01.062-.021.133-.031.195-.164.051-.257.1-.257.175s.092.123.257.174a1.815,1.815,0,0,0,.082.411c-.144.072-.205.134-.185.2s.144.1.318.133a2.636,2.636,0,0,0,.185.329c-.113.082-.164.154-.113.216s.175.092.359.092a2.951,2.951,0,0,0,.359.359c-.082.093-.1.175-.031.226a.652.652,0,0,0,.39.051c.072.051.144.092.215.144-.062.1-.051.185.031.226a.632.632,0,0,0,.4.01c.174.092.37.174.554.257a.189.189,0,0,0,.113.226.665.665,0,0,0,.39-.031l.523.154a.241.241,0,0,0,.185.205.624.624,0,0,0,.38-.082c.226.041.452.082.688.1a.337.337,0,0,0,.257.185.513.513,0,0,0,.339-.123c.1.01.216.01.318.01a.406.406,0,0,0,.3.154.446.446,0,0,0,.308-.154c.236-.01.472-.021.7-.041a.513.513,0,0,0,.359.113.274.274,0,0,0,.236-.195c.185-.031.369-.062.544-.1a.572.572,0,0,0,.39.072.222.222,0,0,0,.164-.216,6.007,6.007,0,0,0,.606-.205.61.61,0,0,0,.4.021.166.166,0,0,0,.082-.226c.082-.041.164-.082.236-.123a.746.746,0,0,0,.411-.01c.082-.051.082-.134.021-.236a3.758,3.758,0,0,0,.441-.318.635.635,0,0,0,.39-.062c.062-.051.031-.133-.062-.236a2.311,2.311,0,0,0,.257-.3c.185-.01.318-.041.359-.1s-.01-.144-.144-.216a3.353,3.353,0,0,0,.185-.39c.185-.031.3-.082.318-.154s-.072-.134-.226-.2a1.13,1.13,0,0,0,.021-.185c.164-.051.267-.113.267-.174s-.1-.123-.267-.175a3.142,3.142,0,0,0-.072-.411c.144-.072.226-.144.2-.205s-.144-.113-.329-.133a1.961,1.961,0,0,0-.185-.318c.123-.082.164-.164.123-.216s-.174-.092-.359-.092a2.954,2.954,0,0,0-.359-.359c.082-.092.1-.174.031-.226a.652.652,0,0,0-.39-.051c-.072-.051-.144-.092-.216-.144.062-.1.051-.185-.021-.226a.632.632,0,0,0-.4-.01,5.377,5.377,0,0,0-.554-.257.173.173,0,0,0-.113-.216.667.667,0,0,0-.39.031,5.068,5.068,0,0,0-.523-.154.254.254,0,0,0-.185-.205.642.642,0,0,0-.37.072c-.226-.041-.462-.082-.7-.113a.324.324,0,0,0-.257-.175.429.429,0,0,0-.328.123c-.113-.01-.226-.01-.339-.01a.38.38,0,0,0-.6,0c-.246.01-.482.021-.718.041a.454.454,0,0,0-.339-.1.316.316,0,0,0-.236.175c-.195.031-.38.062-.575.1a.564.564,0,0,0-.369-.062.21.21,0,0,0-.164.205c-.216.062-.431.133-.636.205a.708.708,0,0,0-.38-.021C1184.194,1962.608,1184.173,1962.69,1184.194,1962.792Z",
    transform: "translate(-1181.7 -1961.9)",
    fill: "#2799c1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1466",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1466",
    d: "M1192.2,1967.658a8.436,8.436,0,0,1,7.616,0c2.1,1.211,2.1,3.182,0,4.393a8.436,8.436,0,0,1-7.616,0C1190.1,1970.84,1190.1,1968.869,1192.2,1967.658Z",
    transform: "translate(-1189.709 -1966.252)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_116",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 116",
    transform: "translate(1.824 1.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1467",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1467",
    d: "M1200.791,1972.615a5.742,5.742,0,0,1,1.457-.565,8.361,8.361,0,0,1,1.252-.185,7.307,7.307,0,0,1,2.125.185,5.072,5.072,0,0,1,1.458.565,2.972,2.972,0,0,1,.975.842,1.8,1.8,0,0,1,.308.729,1.382,1.382,0,0,1,0,.5,1.8,1.8,0,0,1-.308.729,2.971,2.971,0,0,1-.975.842,5.744,5.744,0,0,1-1.458.564,8.357,8.357,0,0,1-1.252.185,6.194,6.194,0,0,1-.872,0,6.457,6.457,0,0,1-1.262-.185,5.066,5.066,0,0,1-1.457-.564,2.969,2.969,0,0,1-.975-.842,1.793,1.793,0,0,1-.308-.729,1.377,1.377,0,0,1,0-.5,1.8,1.8,0,0,1,.308-.729A3.246,3.246,0,0,1,1200.791,1972.615Z",
    transform: "translate(-1199.475 -1971.85)",
    fill: "#2799c1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1468",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1468",
    d: "M1199.6,1994.6h8.878a1.382,1.382,0,0,1,0,.5H1199.6A1.382,1.382,0,0,1,1199.6,1994.6Z",
    transform: "translate(-1197.74 -1991.244)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1469",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1469",
    d: "M1238.8,1971.865a6.192,6.192,0,0,1,.872,0v5.122a6.192,6.192,0,0,1-.872,0v-5.122Z",
    transform: "translate(-1232.939 -1970.829)",
    fill: "#ffc200"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1470",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1470",
    d: "M1203.775,1974.365a5.742,5.742,0,0,1,1.457-.564l5.82,3.366a2.97,2.97,0,0,1-.975.842,5.751,5.751,0,0,1-1.457.565l-5.819-3.366A3.079,3.079,0,0,1,1203.775,1974.365Z",
    transform: "translate(-1200.634 -1972.579)",
    fill: "#fa2209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1471",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1471",
    d: "M1202.8,1977.166l5.819-3.367a5.073,5.073,0,0,1,1.457.565,2.971,2.971,0,0,1,.975.842l-5.82,3.366a5.066,5.066,0,0,1-1.457-.565A3.357,3.357,0,0,1,1202.8,1977.166Z",
    transform: "translate(-1200.634 -1972.578)",
    fill: "#fa2209"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1472",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1472",
    d: "M1205.972,1975.612a6.132,6.132,0,0,1,5.542,0c1.529.883,1.529,2.32,0,3.2a6.13,6.13,0,0,1-5.542,0C1204.443,1977.932,1204.443,1976.495,1205.972,1975.612Z",
    transform: "translate(-1202.451 -1973.611)",
    fill: "#efefef"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_117",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 117",
    transform: "translate(5.885 3.369)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1473",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1473",
    d: "M1239.063,1994.876a.139.139,0,0,0,0,.164.392.392,0,0,0,.092.092.631.631,0,0,0,.575,0,.307.307,0,0,0,.1-.092.153.153,0,0,0,.01-.134.266.266,0,0,0-.1-.113.631.631,0,0,0-.575,0A.215.215,0,0,0,1239.063,1994.876Zm.544-.01c.01.01.031.021.041.031a.092.092,0,0,1-.01.144c-.01.01-.021.01-.031.021a.37.37,0,0,1-.328,0c-.01-.01-.021-.01-.021-.021a.1.1,0,0,1,0-.154l.021-.021A.369.369,0,0,1,1239.607,1994.866Z",
    transform: "translate(-1239.036 -1994.725)",
    fill: "#2799c1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1474",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1474",
    d: "M1240.984,1995.763a.37.37,0,0,1,.328,0c.01.01.031.021.041.031a.093.093,0,0,1-.01.144c-.01.01-.021.01-.031.02a.369.369,0,0,1-.328,0c-.01-.01-.021-.01-.021-.02a.1.1,0,0,1,0-.154C1240.964,1995.774,1240.974,1995.774,1240.984,1995.763Z",
    transform: "translate(-1234.846 -1992.253)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_118",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 118",
    transform: "translate(6.476 3.541)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1475",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1475",
    d: "M1244.821,1996.4l.2.01,3.346.113-3.356.01h-.205C1244.862,1996.492,1244.862,1996.441,1244.821,1996.4Z",
    transform: "translate(-1244.8 -1996.4)",
    fill: "#2799c1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_119",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 119",
    transform: "translate(5.46 3.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1476",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1476",
    d: "M1234.9,1996l.462.021.2.01c-.062.041-.062.1,0,.154h-.626Z",
    transform: "translate(-1234.9 -1996)",
    fill: "#2799c1"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_13",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 13",
    x1: 9.535,
    y1: 5.501,
    transform: "translate(9.874 14.041)",
    fill: "none",
    stroke: "#dbb56b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 16.132
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_14",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 14",
    y1: 11.947,
    x2: 20.692,
    transform: "translate(8.899 7.38)",
    fill: "none",
    stroke: "#dbb56b",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 16.132
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_122",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 122",
    transform: "translate(16.627 8.57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1477",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1477",
    d: "M1343.7,1996.2v1.581l1.016,2.176,3.756.585,2.751-1.591v-1.591Z",
    transform: "translate(-1343.7 -1994.609)",
    fill: "#a2a1a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1478",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1478",
    d: "M1346.461,1980.7l-2.761,1.591,1.016,2.176,3.756.575,2.751-1.591-1.006-2.166Z",
    transform: "translate(-1343.7 -1980.7)",
    fill: "#d3d3d3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1479",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1479",
    d: "M1361.327,1989.806l-.164.1-1.642.944-2.463-.39-.493-1.057-.164-.359,1.806-1.047,2.463.38Z",
    transform: "translate(-1355.097 -1987.251)",
    fill: "#a2a1a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1480",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1480",
    d: "M1362.6,1993.947l-1.642.944-2.463-.39-.493-1.057,1.642-.944,2.463.39Z",
    transform: "translate(-1356.532 -1991.289)",
    fill: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1481",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1481",
    d: "M1353.6,2018.98V2017.4l3.756.575v1.591Z",
    transform: "translate(-1352.584 -2013.633)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1482",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1482",
    d: "M1374,1988v.462l2.463.39v-.472Z",
    transform: "translate(-1370.89 -1987.251)",
    fill: "#b7b7b7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_123",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 123",
    transform: "translate(17.459 17.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1483",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1483",
    d: "M1354.55,2074.642l-2.556-1.468h0a.48.48,0,0,1-.2-.441,1.523,1.523,0,0,1,.677-1.18.469.469,0,0,1,.482-.051h0l2.556,1.468Z",
    transform: "translate(-1351.8 -2071.456)",
    fill: "#ba913f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1484",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1484",
    d: "M1378.055,2086.383c0-.431-.308-.606-.677-.39a1.5,1.5,0,0,0-.677,1.18c0,.431.308.605.677.39A1.54,1.54,0,0,0,1378.055,2086.383Z",
    transform: "translate(-1374.144 -2084.418)",
    fill: "#b28739"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_124",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 124",
    transform: "translate(20.319 19.678)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1485",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1485",
    d: "M1389.939,2096.045a.731.731,0,0,1-.411-.113l-9.535-5.5a.836.836,0,0,1,.831-1.427l9.535,5.5a.827.827,0,0,1,.308,1.129A.851.851,0,0,1,1389.939,2096.045Z",
    transform: "translate(-1379.672 -2088.924)",
    fill: "#dbb56b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_125",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 125",
    transform: "translate(22.539 20.545)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1486",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1486",
    d: "M1424.229,2112.814l-22.652-13.1h0a.664.664,0,0,1-.277-.605,2.06,2.06,0,0,1,.934-1.611.649.649,0,0,1,.657-.062h0l22.652,13.1Z",
    transform: "translate(-1401.3 -2097.375)",
    fill: "#1597ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1487",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1487",
    d: "M1623.868,2225.709c0-.6-.421-.831-.934-.534a2.061,2.061,0,0,0-.934,1.611c0,.6.421.832.934.534A2.061,2.061,0,0,0,1623.868,2225.709Z",
    transform: "translate(-1599.348 -2211.944)",
    fill: "#0b7e99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_126",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 126",
    transform: "translate(5.029 16.204)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1488",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1488",
    d: "M1241.7,2056.9c0-1.632,1.15-2.3,2.566-1.478a5.669,5.669,0,0,1,2.566,4.444c0,1.632-1.15,2.3-2.566,1.478A5.685,5.685,0,0,1,1241.7,2056.9Z",
    transform: "translate(-1240.571 -2055.074)",
    fill: "#1597ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1489",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1489",
    d: "M1236.9,2056.859l1.355-.759,3.6,6.292-1.211.677Z",
    transform: "translate(-1236.264 -2055.995)",
    fill: "#1597ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1490",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1490",
    d: "M1230.7,2063c0-1.632,1.15-2.3,2.566-1.478a5.669,5.669,0,0,1,2.566,4.444c0,1.632-1.15,2.3-2.566,1.478A5.685,5.685,0,0,1,1230.7,2063Z",
    transform: "translate(-1230.7 -2060.548)",
    fill: "#0b7e99"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1491",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1491",
    d: "M1242.5,2077.365c0-.862.605-1.211,1.355-.78a2.981,2.981,0,0,1,1.355,2.34c0,.862-.606,1.211-1.355.78A2.982,2.982,0,0,1,1242.5,2077.365Z",
    transform: "translate(-1241.289 -2074.211)",
    fill: "#9e8b66"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_133",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 133",
    transform: "translate(726.245 289.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1492",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1492",
    d: "M1749.2,1210.876l11.239-54.5.452-2.176,11.341,6.723,5.07,3.007-.482,2.309-11.208,54.367",
    transform: "translate(-1747.445 -1154.2)",
    fill: "none",
    stroke: "#bababa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 25.263
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_128",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 128",
    transform: "translate(0 43.415)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1493",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1493",
    d: "M1749.23,1629.894v1.006l-17.13-9.894V1620Z",
    transform: "translate(-1732.1 -1615.607)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1494",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1494",
    d: "M1756.846,1587.094l-7.616,4.393-17.13-9.894,7.616-4.393Z",
    transform: "translate(-1732.1 -1577.2)",
    fill: "#727272"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1495",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1495",
    d: "M1899,1679v-1.006l7.616-4.393v1.006Z",
    transform: "translate(-1881.87 -1663.706)",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_129",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 129",
    transform: "translate(1.755 34.27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1496",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1496",
    d: "M1766.33,1540.794v1.006l-17.13-9.894V1530.9Z",
    transform: "translate(-1749.2 -1526.507)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1497",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1497",
    d: "M1773.946,1497.994l-7.616,4.393-17.13-9.894,7.616-4.393Z",
    transform: "translate(-1749.2 -1488.1)",
    fill: "#7c7c7c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1498",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1498",
    d: "M1916.1,1589.9v-1.006l7.616-4.393v1Z",
    transform: "translate(-1898.97 -1574.606)",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_130",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 130",
    transform: "translate(3.51 25.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1499",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1499",
    d: "M1783.43,1453.494v1.006l-17.13-9.894V1443.6Z",
    transform: "translate(-1766.3 -1439.207)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1500",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1500",
    d: "M1791.046,1410.694l-7.616,4.393-17.13-9.894,7.616-4.393Z",
    transform: "translate(-1766.3 -1400.8)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1501",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1501",
    d: "M1933.2,1502.6v-1.006l7.616-4.393v1Z",
    transform: "translate(-1916.07 -1487.306)",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_131",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 131",
    transform: "translate(5.265 16.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1502",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1502",
    d: "M1800.53,1366.584v1.006l-17.13-9.884V1356.7Z",
    transform: "translate(-1783.4 -1352.307)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1503",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1503",
    d: "M1808.146,1323.784l-7.616,4.393-17.13-9.884,7.616-4.393Z",
    transform: "translate(-1783.4 -1313.9)",
    fill: "#919191"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1504",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1504",
    d: "M1950.3,1415.6v-1.006l7.616-4.393v1.006Z",
    transform: "translate(-1933.17 -1400.316)",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_132",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 132",
    transform: "translate(7.02 7.328)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1505",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1505",
    d: "M1817.63,1278.294v1.006l-17.13-9.894V1268.4Z",
    transform: "translate(-1800.5 -1264.007)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1506",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1506",
    d: "M1825.246,1235.494l-7.616,4.393-17.13-9.894,7.616-4.393Z",
    transform: "translate(-1800.5 -1225.6)",
    fill: "#a0a0a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1507",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1507",
    d: "M1967.4,1327.4v-1.006l7.616-4.393v1Z",
    transform: "translate(-1950.27 -1312.106)",
    fill: "#515151"
  })), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1508",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1508",
    d: "M1999.9,1360.9l9.289,31.735.452,1.55.513,1.776",
    transform: "translate(-1972.414 -1339.685)",
    fill: "none",
    stroke: "#b2b2b2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 25.263
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\u041B\\u0438\\u043D\\u0438\\u044F_15",
    "data-name": "\\u041B\\u0438\\u043D\\u0438\\u044F 15",
    x1: 14.615,
    y2: 8.519,
    transform: "translate(20.414 47.008)",
    fill: "none",
    stroke: "#bababa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 11.228
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1509",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1509",
    d: "M1920.79,1249l-10.89,52.8-.39,1.909-.411,1.971",
    transform: "translate(-1890.933 -1239.27)",
    fill: "none",
    stroke: "#bababa",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 25.263
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1510",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1510",
    d: "M1858.7,1156.376l.452-2.176,11.341,6.723,5.07,3.007-.482,2.309",
    transform: "translate(-1845.706 -1154.2)",
    fill: "none",
    stroke: "#939393",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 33.243
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_134",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 134",
    transform: "translate(730.594 239.097)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1511",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1511",
    d: "M1932.48,742.284c.5.062-.585,2.145-.585,2.145s1.519-2.781,1.991-2.607c.523.185-.9,2.864-.9,2.864s1.889-3.192,2.186-2.976-1.324,3.623-1.324,3.623,1.889-3.274,2.238-2.915-2.022,4.752-2.217,5.173a.7.7,0,0,0-.062.482c.77-.41,1.488-1.724,2.053-1.858.647-.154.677.144,0,1.078a9.565,9.565,0,0,1-2.463,2.474.906.906,0,0,0-.1.062c-.041.031-.092.051-.133.082-.606.308-1.437.462-1.529.821l-.493,1-2.535-1.714a8.715,8.715,0,0,0,.585-2.576c.072-1.355,1.622-2.894,1.7-3.089S1931.967,742.222,1932.48,742.284Z",
    transform: "translate(-1912.781 -733.991)",
    fill: "#ffd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1512",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1512",
    d: "M1810.534,823.435c1.17.144,6.21-4.044,6.21-4.044s1.971-.072,2.6,1l.616,1.078a93.449,93.449,0,0,1-5.142,7.9c-1.478,1.714-3.674.9-9.073-.883C1800.363,826.7,1809.364,823.291,1810.534,823.435Z",
    transform: "translate(-1801.007 -803.709)",
    fill: "#f9d950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1513",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1513",
    d: "M1828.345,773.4a1.843,1.843,0,0,1-.647,2.227,2.5,2.5,0,0,0,1.95,2.309c2.012.667,5.1-.133,5.1-.133s-1.3-2.884-.113-4.9-2.084-2.073-2.238-2.155-3.756.821-3.921,1.2A5.191,5.191,0,0,0,1828.345,773.4Z",
    transform: "translate(-1822.235 -760.06)",
    fill: "#ffd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1514",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1514",
    d: "M1795.085,1397.119c-1,1.437-1.519,2.843-1.026,3.705.37.636,2.771.441,4.465.226s5.07-.9,5.737-1.776.082-1.755-1.17-1.889-3.582-.39-4.393-1.457S1795.085,1397.119,1795.085,1397.119Z",
    transform: "translate(-1791.879 -1320.819)",
    fill: "#1f5b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1515",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1515",
    d: "M1805.189,1379.573a7.991,7.991,0,0,1-.739,2.607c-.133.205,2.094,1.221,3.479.811s1.108-1.5,1.108-1.5-.585-.236-.441-1.447-.411-1.345-.411-1.345Z",
    transform: "translate(-1801.368 -1305.613)",
    fill: "#f9ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1516",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1516",
    d: "M1857.726,1473.651a3.426,3.426,0,0,0-.472,2.463c.041.718.862.78,2.227.534s6.61-1.889,7.441-3,1.047-2.186.277-3.079-2.217-.216-3.572,0a4.8,4.8,0,0,1-2.679-.123,8.922,8.922,0,0,0-2.771-.031l.339,2.494Z",
    transform: "translate(-1848.722 -1387.653)",
    fill: "#236188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1517",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1517",
    d: "M1862.587,1468.749a12.887,12.887,0,0,1-.154,2.063l-.134.472a2.692,2.692,0,0,0,2.227.523c1.447-.226,1.437-1.94,1.447-2.35s-.462-1.057-.4-1.8S1862.587,1468.749,1862.587,1468.749Z",
    transform: "translate(-1853.285 -1385.285)",
    fill: "#ffd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1518",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1518",
    d: "M1803.278,1076.7c-.6,4.105,1.427,4.8,3.644,7.79a20.956,20.956,0,0,0,3.459,3.921,22.271,22.271,0,0,0-4.424,9.833,64.227,64.227,0,0,1-2.535,10.325,4.045,4.045,0,0,0,2.864.739c1.663-.226,1.847-.688,1.847-.688l7.339-19.737s-3.49-10-5.686-10.962A24.822,24.822,0,0,0,1803.278,1076.7Z",
    transform: "translate(-1800.227 -1034.609)",
    fill: "#1f5b7a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1519",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1519",
    d: "M1833.4,1087.5c.431,4.608,3.756,9.6,4.3,13.4s-.185,7.564-.862,12.912a107.173,107.173,0,0,0-.431,13.343s1.786.893,2.617.154a10.344,10.344,0,0,0,1.416-1.57s3.849-17.346,4.516-19.306,2.812-10.633.954-16.463S1833.4,1087.5,1833.4,1087.5Z",
    transform: "translate(-1827.352 -1043.434)",
    fill: "#236188"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1520",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1520",
    d: "M2116.37,740.994c-.482-.174-1.16,1.468-1.16,1.468s.852-2.915.4-3.141c-.493-.246-1.17,2.556-1.17,2.556s1.057-3.962.493-4.085c-.349-.072-1.714,3.849-1.714,3.849s1-3.654.493-3.664-2.053,4.742-2.217,5.173a.7.7,0,0,1-.308.38c-.226-.842.226-2.268-.062-2.771-.329-.575-.575-.39-.78.739a9.784,9.784,0,0,0-.092,3.49c.01.041.021.082.031.113a.855.855,0,0,0,.041.154c.2.647.657,1.355.462,1.673l-.38,1.047,3,.657a8.742,8.742,0,0,1,1.468-2.2c.934-.985.955-3.1,1.037-3.295C2115.969,742.934,2116.657,741.1,2116.37,740.994Z",
    transform: "translate(-2075.681 -730.484)",
    fill: "#ffd983"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1521",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1521",
    d: "M1793.953,847.708s-.585,3.325-5.871,2.556-9.8-1.765-10.664-3.182.708-7.564-.092-10.941c-.513-2.176-1-4.793-1.56-7.523-.308-1.509-.646-3.059-1.016-4.588-1.047-4.29.872-8.211,5.193-7.154a55.458,55.458,0,0,1,7.041,2.166c3.438,2.217,5.306,3.377,6.148,5.009.523,1.006-.421,5.44-.1,10.828.174,2.956.051,5.758.257,6.907C1793.778,844.659,1793.953,847.708,1793.953,847.708Z",
    transform: "translate(-1774.469 -801.296)",
    fill: "#357fa5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1522",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1522",
    d: "M1805.287,951.891s-.585,3.325-5.871,2.556-9.8-1.765-10.664-3.182.708-7.564-.092-10.941c-.513-2.176-1-4.793-1.56-7.523,6.5,6.281,12.747,3.449,12.747,3.449s.421.759,1.057,1.93c-.544,2.915.975,6.764,1.355,7.862A27.878,27.878,0,0,0,1805.287,951.891Z",
    transform: "translate(-1785.804 -905.479)",
    fill: "#f4d13d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1523",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1523",
    d: "M1858.8,709.875a22.436,22.436,0,0,1,.195,4.27c-.082.174.328.842.667,1.119s-.185.729-.4,1.047.318,1.293-1.078,2.73-2.032.985-2.761.154a20.192,20.192,0,0,1-2.1-2.946c-.739-1.283-1.324-2.237-1.324-2.237s2.227-3.141,3.428-3.869S1858.8,709.875,1858.8,709.875Z",
    transform: "translate(-1844.042 -705.308)",
    fill: "#f9ce78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1524",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1524",
    d: "M1821.678,695.7c1.375.913,1.139,2.8.205,4.064s-1.776,3.325-1.529,4.085.38.934.021.9-.226-1.447-1-1.406-1.18,1.642-.9,2.412-3.059,1.981-4.331,1.365.287-.883-1.7-1.8c-2.176-1,.441-3.459.441-3.459Z",
    transform: "translate(-1807.768 -692.714)",
    fill: "#4b5366"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1525",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1525",
    d: "M1791.668,679.168c-3.387-2.022-4.167-6.928-.924-9.114,8.18-5.5,11.6-3.059,12.265-1.868,1.416,2.556-1.139,4.957-3.572,7.841C1796.984,678.911,1793.094,679.537,1791.668,679.168Z",
    transform: "translate(-1787.22 -666.606)",
    fill: "#374057"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1526",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1526",
    d: "M1905.829,833.754c-2.864-2.8,1.221-6.712,4.465-6.558s10.8.657,11.937.328,4.136-6.148,4.136-6.148,1.786-.842,2.781-.092l.985.749a92.777,92.777,0,0,1-1.652,9.278c-.7,2.166-3.038,2.258-8.693,2.72S1907.235,835.13,1905.829,833.754Z",
    transform: "translate(-1891.478 -805.13)",
    fill: "#f9d950"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1527",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1527",
    d: "M1816,810.895c.677-1.324,1.734-1.016,4.8,0s3.869,1.18,4.311,2.7C1825.114,813.584,1818.648,811.079,1816,810.895Z",
    transform: "translate(-1811.737 -795.294)",
    fill: "#f9d950"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_135",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 135",
    transform: "translate(734.637 359.711)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1528",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1528",
    d: "M1840.327,1848.4v-.688l-.677.862-2.032.534-1.129-.5.051-.914,2.258-.708v-.688l-1.078.339a3.058,3.058,0,0,0-1.324-.062,3.305,3.305,0,0,0-2.268,1.457c-.287.677-.082.975-1,1.509l-14.8,8.539a8.2,8.2,0,0,1-2.771.646h0a3.107,3.107,0,0,0-.954.349,1.079,1.079,0,0,0,0,2.042,3.892,3.892,0,0,0,3.531,0,2.62,2.62,0,0,0,.246-.164,1.114,1.114,0,0,0,.195-.185,1.006,1.006,0,0,0,.236-.4,4.287,4.287,0,0,1,1.314-1.242s13.127-7.7,14.421-8.324,2.669-.154,4.29-.831S1840.327,1848.4,1840.327,1848.4Zm-23.042,12.224a2.022,2.022,0,0,1-1.847,0,.562.562,0,0,1,0-1.067,2.022,2.022,0,0,1,1.847,0A.562.562,0,0,1,1817.285,1860.628Z",
    transform: "translate(-1813.874 -1845.835)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1529",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1529",
    d: "M1814.595,1856.354a3.893,3.893,0,0,0,3.531,0,2.581,2.581,0,0,0,.246-.164,1.128,1.128,0,0,0,.195-.185,1.01,1.01,0,0,0,.236-.4,4.289,4.289,0,0,1,1.314-1.242s13.127-7.7,14.42-8.324,2.669-.154,4.29-.831,1.478-1.56,1.478-1.56l-2.71.708-1.129-.5.051-.913,2.258-.708a4.84,4.84,0,0,0-2.4-.421,3.305,3.305,0,0,0-2.268,1.458c-.287.677-.082.975-1,1.509l-14.8,8.539a8.2,8.2,0,0,1-2.771.647h0a3.11,3.11,0,0,0-.955.349A1.081,1.081,0,0,0,1814.595,1856.354Zm.842-.482a.562.562,0,0,1,0-1.067,2.023,2.023,0,0,1,1.847,0,.562.562,0,0,1,0,1.067A2.087,2.087,0,0,1,1815.437,1855.872Z",
    transform: "translate(-1813.862 -1841.766)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1530",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1530",
    d: "M1884.939,1876.113a.174.174,0,0,1-.062.062l-8.642,4.988-4.783,2.761a.315.315,0,0,1-.328,0l-.328-.195a.183.183,0,0,1-.072-.082.2.2,0,0,1,.072-.257l4.783-2.761,8.652-5a.283.283,0,0,1,.257,0l.4.236A.2.2,0,0,1,1884.939,1876.113Z",
    transform: "translate(-1864.87 -1872.127)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1531",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1531",
    d: "M1885.115,1877.639a.175.175,0,0,1-.062.062l-8.642,4.988-4.783,2.761a.315.315,0,0,1-.328,0l-.329-.2a.182.182,0,0,1-.072-.082.277.277,0,0,1,.072-.082l4.783-2.761,8.652-5a.283.283,0,0,1,.256,0l.4.236C1885.074,1877.587,1885.095,1877.608,1885.115,1877.639Z",
    transform: "translate(-1865.046 -1873.653)",
    fill: "#d1d1d1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_136",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 136",
    transform: "translate(746.691 368.801)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1532",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1532",
    d: "M1965.956,1938.458v-.862l-.862,1.088-2.556.667-1.416-.636.041-.852.021-.308,2.843-.893v-.862l-1.355.421a3.976,3.976,0,0,0-1.663-.082,4.163,4.163,0,0,0-2.864,1.847c-.359.852-.092,1.232-1.262,1.9-1,.575-11.988,6.846-15.683,8.981l1.252,1.037v.862c2.935-1.714,14.769-8.591,16.227-9.3,1.632-.8,3.356-.195,5.409-1.047C1966.141,1939.587,1965.956,1938.458,1965.956,1938.458Z",
    transform: "translate(-1940.184 -1935.239)",
    fill: "#b7b7b7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1533",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1533",
    d: "M1957.072,1932.689l-3.418.893-1.375-.616-.041-.021.062-1.149,1.488-.462,1.355-.421a6.045,6.045,0,0,0-3.017-.523,4.154,4.154,0,0,0-2.864,1.837c-.359.852-.092,1.232-1.262,1.9-1.067.616-14.2,8.129-16.7,9.566l2.279,1.314a.053.053,0,0,1,.041-.021s14.554-8.478,16.186-9.278,3.356-.2,5.409-1.047c1.591-.657,1.837-1.488,1.868-1.817A.879.879,0,0,0,1957.072,1932.689Z",
    transform: "translate(-1931.3 -1930.332)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1534",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1534",
    d: "M1964.619,1973.492a.21.21,0,0,1-.082.082l-10.89,6.292-4.034,2.258a.418.418,0,0,1-.411,0l-.421-.246a.224.224,0,0,1-.092-.1.261.261,0,0,1,.092-.328l4.034-2.258,10.9-6.292a.3.3,0,0,1,.318,0l.5.287A.234.234,0,0,1,1964.619,1973.492Z",
    transform: "translate(-1946.883 -1968.486)",
    fill: "#c6c6c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1535",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1535",
    d: "M1964.829,1975.466a.209.209,0,0,1-.082.082l-10.89,6.292-4.034,2.258a.418.418,0,0,1-.411,0l-.421-.246a.225.225,0,0,1-.092-.1.29.29,0,0,1,.092-.1l4.034-2.258,10.9-6.292a.3.3,0,0,1,.318,0l.5.287A.314.314,0,0,1,1964.829,1975.466Z",
    transform: "translate(-1947.094 -1970.461)",
    fill: "#d1d1d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1536",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1536",
    d: "M1933.579,2062.586l-2.279-1.314v-.872l2.279,1.324Z",
    transform: "translate(-1931.3 -2047.05)",
    fill: "#c6c6c6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_137",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 137",
    transform: "translate(740.113 364.692)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1537",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1537",
    d: "M1963.821,1890.752l-14.831,8.56-.79-.452,14.831-8.56Z",
    transform: "translate(-1939.887 -1890.3)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1538",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1538",
    d: "M1881.662,1954.3c-1.642,2.073-10.284,6.641-10.284,6.641l-.4-.564-.76-1.078-.318-.452c5.05-2.689,9.155-5.44,11.033-5.625a.9.9,0,0,1,.965.37C1881.991,1953.758,1881.9,1954,1881.662,1954.3Z",
    transform: "translate(-1869.624 -1946.758)",
    fill: "#f4bc1e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1539",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1539",
    d: "M1884.444,1954.212l-10.684,6.076-.76-1.078.021-.133,10.695-5.953a.9.9,0,0,1,.965.37C1884.772,1953.668,1884.68,1953.915,1884.444,1954.212Z",
    transform: "translate(-1872.406 -1946.668)",
    fill: "#f9c623"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1540",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1540",
    d: "M1867.487,2007.45c-.842.575.411,2.679,1.488,2.094S1868.205,2006.968,1867.487,2007.45Z",
    transform: "translate(-1867.211 -1995.359)",
    fill: "#ffd637"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_138",
    "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 138",
    transform: "translate(743.593 365.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1541",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1541",
    d: "M2004.321,1915.362l-14.831,8.56-.79-.462,14.831-8.56Z",
    transform: "translate(-1979.711 -1913.504)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1542",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1542",
    d: "M1916.645,1978.462c-1.765,2.227-11.054,7.143-11.054,7.143l-.431-.605-.821-1.16-.339-.482c5.44-2.894,9.843-5.85,11.865-6.056a.965.965,0,0,1,1.037.4C1917,1977.877,1916.9,1978.144,1916.645,1978.462Z",
    transform: "translate(-1903.704 -1969.491)",
    fill: "#ea4b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1543",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1543",
    d: "M1919.606,1978.461,1908.121,1985l-.821-1.16.021-.144,11.5-6.394a.965.965,0,0,1,1.037.4C1919.965,1977.876,1919.863,1978.143,1919.606,1978.461Z",
    transform: "translate(-1906.665 -1969.491)",
    fill: "#f25451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1544",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1544",
    d: "M1901.411,2035.613c-.9.616.441,2.874,1.6,2.258S1902.171,2035.1,1901.411,2035.613Z",
    transform: "translate(-1901.115 -2021.757)",
    fill: "#f45c58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1545",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1545",
    d: "M2132.619,1902.7c.092-.8,2.556-1.4,2.556-1.4l.1.072a3.445,3.445,0,0,1-1.858,1.786C2133.409,1903.158,2132.27,1903.3,2132.619,1902.7Z",
    transform: "translate(-2108.799 -1901.3)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1546",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1546",
    d: "M2150.024,1901.3l-.924.534,1.016-.462Z",
    transform: "translate(-2123.648 -1901.3)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1547",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1547",
    d: "M2153.526,1902l-.626.719.575-.606Z",
    transform: "translate(-2127.058 -1901.928)",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_1548",
    "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 1548",
    d: "M2149.4,1901.3l-1,.318.79-.267Z",
    transform: "translate(-2123.02 -1901.3)",
    fill: "#848484"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilder1);
export default __webpack_public_path__ + "static/media/builder1.ce2875d2d5c95b589be3c4c193835223.svg";
export { ForwardRef as ReactComponent };